{
  "common": {
    "appTitle": "Draughts MVP",
    "back": "Wstecz",
    "exit": "Wyjdź",
    "cancel": "Anuluj",
    "close": "Zamknij",
    "continue": "Kontynuuj",
    "copy": "Kopiuj",
    "error": "Błąd",
    "loading": "Ładowanie...",
    "retry": "Ponów",
    "or": "lub",
    "vs": "vs",
    "you": "Ty",
    "anonymous": "Anonim",
    "send": "Wyślij",
    "download": "Pobierz",
    "noLimit": "Bez limitu",
    "comingSoon": "Wkrótce",
    "version": "v{{version}}",
    "enabled": "Włączone",
    "disabled": "Wyłączone",
    "apply": "Zastosuj",
    "errorBoundary": "Coś poszło nie tak. Spróbuj odświeżyć: jeśli właśnie pojawiła się nowa wersja, odświeżenie ją pobierze.",
    "dismissNotice": "Zamknij"
  },
  "errors": {
    "loadFailed": "Nie udało się wczytać tych danych. Spróbuj ponownie.",
    "network": "Brak połączenia z internetem. Sprawdź sieć i spróbuj ponownie.",
    "notFound": "Ta strona nie istnieje (już)."
  },
  "senzaRete": {
    "titolo": "Jesteś offline",
    "dati": "Ta strona nie może wczytać swoich danych, dopóki połączenie nie wróci.",
    "home": "Gry online, turnieje i ranking są niedostępne. Nadal możesz zagrać z komputerem albo na żywo na tym urządzeniu."
  },
  "avvisoServizio": {
    "etichetta": "Komunikat serwisowy",
    "preset": {
      "riavvio": "Zaplanowany restart: serwer będzie chwilowo niedostępny. Trwające partie nie przepadną.",
      "riavvioAlle": "Zaplanowany restart o {{ora}}: serwer będzie chwilowo niedostępny. Trwające partie nie przepadną.",
      "manutenzione": "Trwa konserwacja: niektóre funkcje mogą być niedostępne.",
      "manutenzioneAlle": "Konserwacja od {{ora}}: niektóre funkcje mogą być niedostępne.",
      "rallentamenti": "Serwer działa wolniej niż zwykle. Pracujemy nad tym."
    }
  },
  "nav": {
    "play": "Graj",
    "tournaments": "Turnieje",
    "leaderboard": "Ranking",
    "myGames": "Moje Gry",
    "logout": "Wyloguj",
    "signIn": "Zaloguj się",
    "backToLocal": "Powrót do Gry Lokalnej",
    "backToTournaments": "Powrót do Turniejów",
    "backToGames": "Powrót do Gier",
    "home": "Home",
    "arena": "Arena",
    "profile": "Profil",
    "loginRequired": "Wymagane logowanie",
    "faq": "FAQ i Kontakt",
    "rules": "Zasady",
    "editor": "Edytor",
    "strumenti": "Tools"
  },
  "gara": {
    "torneoInCorso": "Turniej trwa",
    "arenaInCorso": "Arena trwa"
  },
  "strumenti": {
    "titoloFoglio": "Tools (Narzędzia)",
    "orologio": "Zegar",
    "estraiApertura": "Wylosuj otwarcie"
  },
  "orologio": {
    "titolo": "Zegar turniejowy",
    "sottotitolo": "Połóż telefon między graczami: kto wykonał ruch, dotyka swojej połowy",
    "tocca": "Dotknij, aby rozpocząć",
    "pausa": "Pauza",
    "riprendi": "Wznów",
    "azzera": "Zeruj",
    "impostazioni": "Ustawienia",
    "suoni": "Dźwięki",
    "suonoTocco": "Dźwięk dotknięcia",
    "suonoPocoTempo": "Dźwięk niskiego czasu",
    "tempo": "Czas",
    "stessoTempo": "Ten sam czas dla obu",
    "scaduto": "Czas minął",
    "mosse": "Ruchy"
  },
  "apertura": {
    "sottotitolo": "Wylosuj oficjalne otwarcie",
    "andataRitorno": "To otwarcie może faworyzować jeden kolor: w zawodach gra się mecz i rewanż, z odwróconymi kolorami.",
    "estrai": "Wylosuj",
    "estraiDiNuovo": "Wylosuj ponownie",
    "vediTabelle": "Zobacz pełne tabele",
    "posizioneIniziale": "Pozycja początkowa"
  },
  "editor": {
    "title": "Edytor",
    "subtitle": "Ułóż pozycję do analizy, nauki lub gry",
    "boardLabel": "Edytowalna plansza",
    "sideToMove": "Ruch",
    "reset": "Resetuj",
    "clear": "Wyczyść",
    "flip": "Obróć",
    "playPosition": "Zagraj pozycję",
    "playAI": "Graj z komputerem",
    "challenge": "Wyzwij znajomego",
    "challengeNote": "Partia zaczyna się od Twojej pozycji i zawsze jest towarzyska (bez rankingu).",
    "tools": {
      "label": "Bierki",
      "whiteMan": "Biały pionek",
      "whiteKing": "Biała damka",
      "blackMan": "Czarny pionek",
      "blackKing": "Czarna damka",
      "erase": "Wymaż",
      "cycle": "Zmień bierkę"
    },
    "library": {
      "open": "Zapisane pozycje",
      "title": "Zapisane pozycje",
      "nameLabel": "Nazwa",
      "namePlaceholder": "Nazwa pozycji",
      "defaultName": "Pozycja",
      "defaultNameAnalysis": "Analiza",
      "save": "Zapisz",
      "overwrite": "Nadpisz",
      "willOverwrite": "„{{name}}” zostanie zastąpiona.",
      "saved": "W bibliotece",
      "empty": "Brak zapisanych pozycji. Ułóż pozycję i zapisz ją tutaj.",
      "load": "Wczytaj {{name}}",
      "lineBadge_one": "{{count}} ruch",
      "lineBadge_few": "{{count}} ruchy",
      "lineBadge_many": "{{count}} ruchów",
      "lineBadge_other": "{{count}} ruchów",
      "askLoad": "Wczytać „{{name}}”? Pozycja na planszy zostanie zastąpiona.",
      "askLoadLine": "Wczytać „{{name}}”? Pozycja i rozgrywany wariant zostaną zastąpione.",
      "confirmLoad": "Wczytaj",
      "rename": "Zmień nazwę {{name}}",
      "share": "Udostępnij {{name}}",
      "shareCopied": "Skopiowano link",
      "shareTitle": "Pozycja warcabowa",
      "shareText": "Zobacz tę pozycję warcabową",
      "delete": "Usuń {{name}}",
      "askDelete": "Usunąć „{{name}}”?",
      "confirmDelete": "Usuń",
      "errors": {
        "nameTaken": "Pozycja o tej nazwie już istnieje.",
        "full": "Biblioteka pełna: usuń pozycję, aby zapisać nową.",
        "saveFailed": "Nie udało się zapisać. Spróbuj ponownie.",
        "deleteFailed": "Nie udało się usunąć. Spróbuj ponownie.",
        "loadFailed": "Nie można odczytać tej pozycji.",
        "loadListFailed": "Nie udało się wczytać biblioteki.",
        "shareFailed": "Nie udało się skopiować linku."
      }
    },
    "fen": {
      "label": "Pozycja (FEN)",
      "copy": "Kopiuj FEN",
      "copied": "Skopiowano",
      "invalid": "Nieprawidłowy FEN."
    },
    "analysis": {
      "title": "Analiza",
      "hint": "Graj oboma kolorami. Cofnij się i zagraj inny ruch, aby zmienić wariant.",
      "save": "Zapisz analizę",
      "run": "Analizuj",
      "depth": "Głębokość",
      "fast": "Szybka",
      "standard": "Standard",
      "deep": "Głęboka",
      "evaluation": "Ocena",
      "cancel": "Anuluj",
      "reached": "Osiągnięta głębokość"
    },
    "invalid": {
      "noWhite": "Dodaj co najmniej jeden biały pionek.",
      "noBlack": "Dodaj co najmniej jeden czarny pionek.",
      "manOnPromotionRow": "Pionek nie może stać na linii promocji — zmień go w damkę lub przesuń.",
      "tooManyPieces": "Zbyt wiele bierek dla tego wariantu.",
      "sideToMoveNoMoves": "Strona na ruchu nie ma legalnych ruchów.",
      "alreadyTerminal": "Ta pozycja jest już rozstrzygnięta (wygrana lub remis).",
      "offBoard": "Bierka stoi na polu, którego ten wariant nie ma.",
      "duplicateSquare": "Dwie bierki na tym samym polu."
    }
  },
  "rules": {
    "channels": {
      "cta": "Polecane kanały",
      "title": "Polecane kanały",
      "note": "Kanały, które polecamy do oglądania i nauki tego wariantu.",
      "opensOnYouTube": "Otwiera się w YouTube"
    },
    "backToRules": "Wszystkie zasady",
    "playOnline": "Zagraj teraz",
    "playAI": "Graj z komputerem",
    "indexTitle": "Zasady warcabów",
    "indexIntro": "Dwa regulaminy w jednym miejscu: zasady gry każdego obsługiwanego wariantu i zasady, według których działają nasze turnieje online.",
    "gameTitle": "Zasady warcabów według wariantu",
    "gameIntro": "Warcaby — znane też jako draughts, checkers, dama i dammen — gra się na całym świecie, każdy region ma własne zasady. Przeglądaj poniżej zasady każdego obsługiwanego wariantu.",
    "gameCtaDesc": "Plansza, ruchy, bicie i promocja — wariant po wariancie.",
    "heroSubtitle": "Zasady, ustawienie początkowe i jak grać w {{variant}}.",
    "startingPosition": "Ustawienie początkowe",
    "howToPlay": "Jak grać",
    "otherVariants": "Inne warianty",
    "eyebrow": "Zasady",
    "glance": {
      "title": "W skrócie",
      "board": "Plansza",
      "pieces": "Pionki na stronę",
      "starts": "Zaczyna"
    },
    "theme": {
      "movement": "Ruch",
      "capture": "Bicie",
      "promotion": "Promocja"
    },
    "variantsLabel": "Warianty",
    "draughtsWord": "warcaby",
    "tournaments": {
      "title": "Zasady turniejów",
      "heroSubtitle": "Wszystko, co turniej rozstrzyga sam, od liczby rund po punktację pomocniczą.",
      "intro": "Po starcie turniej toczy się sam: liczy obecnych zapisanych, wybiera system kojarzenia, ustala liczbę rund i układa tabelę. Oto zasady, które stosuje, w kolejności, w jakiej je stosuje.",
      "source": "Źródło: FIDE C.04.1 i FMJD Annex 3, dostosowane do gry online.",
      "cta": "Jak działa turniej",
      "ctaDesc": "System rozgrywki, rundy, zapisy, nieobecności, punktacja pomocnicza i arena.",
      "chaptersLabel": "Rozdziały",
      "format": {
        "title": "System rozgrywki",
        "body": [
          "Tylko jeden format rundowy, kołowy/szwajcarski: kto otwiera turniej, nie wybiera między systemem kołowym a szwajcarskim, tylko wybiera próg liczby zapisanych. Obok turniejów jest arena, a to co innego: zobacz rozdział „Arena”.",
          "O godzinie startu liczy się faktycznie zapisanych. Poniżej progu gra się system kołowy: każdy z każdym, według tabel Bergera. Od progu w górę gra się systemem szwajcarskim: w każdej rundzie kojarzy się graczy o tej samej liczbie punktów i nigdy nie gra się dwa razy z tym samym przeciwnikiem.",
          "Domyślny próg to 7 i można go ustawić między 7 a 20; system kołowy przyjmuje najwyżej 19 zapisanych.",
          "Powód jest prosty: przy otwieraniu turnieju nikt nie wie, ilu przyjdzie, a wybór formatu z góry to wybór w ciemno.",
          "Wygrana 2 punkty, remis 1 punkt, przegrana zero. Przy nieparzystej liczbie zapisanych w każdej rundzie jeden pauzuje, a ile ta pauza jest warta, zależy od formatu: w systemie szwajcarskim daje 2 punkty jak wygrana — 4 w turnieju z rewanżami, gdzie każda runda to dwie partie — natomiast w systemie kołowym nie daje żadnego punktu, bo tam każdy gra z każdym, a pauza to tylko runda, której się nie rozgrywa. W żadnym z tych przypadków nie liczy się jako wygrana partia ani nie wchodzi do kryteriów dodatkowych."
        ]
      },
      "rounds": {
        "title": "Liczba rund",
        "body": [
          "Liczbę ustala start turnieju na podstawie obecnych zapisanych. Przy domyślnym progu, według liczby zapisanych:",
          "Turniej przyjmuje najwyżej 200 zapisanych, więc dziesięć rund to maksimum — jedenaście z dodatkową rundą.",
          "W systemie kołowym rund jest tyle, ile trzeba, żeby każdy zagrał z każdym. Przy trzech lub czterech zapisanych mecz i rewanż rozgrywa się zawsze, niezależnie od wyboru organizatora: każda runda to wtedy dwie partie, bo przy jednej partii z każdym rywalem jedna porażka w pierwszej rundzie już rozstrzygałaby turniej. Przy czterech są to trzy rundy i sześć partii na osobę; przy trzech gra się te same trzy rundy, ale za każdym razem ktoś pauzuje, więc każdy pauzuje raz i gra cztery partie — a runda pauzy nie daje punktów.",
          "W systemie szwajcarskim podwojenie stawki dodaje jedną rundę: każda runda o połowę zmniejsza liczbę graczy, którzy wciąż mogą skończyć z kompletem punktów. To o jedną rundę więcej, niż potrzebowałby turniej pucharowy, bo inaczej dwóch graczy mogłoby skończyć na czele, nigdy ze sobą nie grając.",
          "Dwa przełączniki zmieniają rachunek. «Dodatkowa runda» dokłada jedną do tabeli, gdy stawka to udźwignie, i działa tylko wtedy, gdy start da system szwajcarski: w kołowym wszyscy i tak grają ze wszystkimi, a runda więcej byłaby tylko rewanżem dla wszystkich. «Mecz i rewanż» natomiast nie dokłada rund, tylko je wypełnia: każde skojarzenie rozgrywa się dwa razy pod rząd, z odwróconymi kolorami i na tym samym otwarciu, w obrębie tej samej rundy, która przez to trwa dwa razy dłużej. Działa tak samo w kołowym i w szwajcarskim, a punkty pozostają za partię: wygrana i remis dają 3, dwie wygrane 4."
        ],
        "rounds": [
          "3-4 — kołowy, 3 rundy",
          "5-6 — kołowy, 5 rund",
          "7-8 — szwajcarski, 4 rundy",
          "9-16 — szwajcarski, 5 rund",
          "17-32 — szwajcarski, 6 rund",
          "33-64 — szwajcarski, 7 rund",
          "65-128 — szwajcarski, 8 rund",
          "129-192 — szwajcarski, 9 rund",
          "193-200 — szwajcarski, 10 rund"
        ]
      },
      "entry": {
        "title": "Zapisy i wycofanie",
        "body": [
          "Otworzyć turniej może każdy, kto ma zarejestrowane konto: nie trzeba pozwolenia i nie ma oficjalnego organizatora. Goście i komputery do turniejów nie wchodzą, ani żeby je otwierać, ani żeby w nich grać.",
          "Trzy żywe rozgrywki na osobę: możesz mieć otwarte do trzech turniejów lub aren jednocześnie; aby otworzyć następną, poczekaj, aż jedna się zakończy, albo ją odwołaj.",
          "Turniej się planuje, nie uruchamia ręcznie: początek ustala się od pięciu minut do czternastu dni naprzód. Kto go otwiera, tylko go organizuje: żeby zagrać, musi na stronie turnieju nacisnąć «Zapisz się» jak wszyscy inni, a dopóki tego nie zrobi, nie liczy się do stawki — minimum 3 oznacza trzy osoby oprócz niego.",
          "Miejsc jest od 3 do 200. Minimum do startu to 3, a otwierający może je podnieść: jeśli o godzinie startu zapisanych jest mniej niż minimum, turniej sam się odwołuje. Dopóki się nie zaczął, otwierający może go odwołać; potem już nie, bo kto gra, ma prawo dokończyć.",
          "Turniej może być prywatny: wchodzi się tylko z hasłem wybranym przez otwierającego albo z linkiem z zaproszeniem.",
          "Zapisać się można do startu pierwszej rundy i do tego momentu można też się wycofać — kto anuluje zapis przed startem, znika z tabeli od razu, bo nic jeszcze nie rozegrał. Od tej chwili drzwi zamykają się w obie strony: kto jest w środku, zostaje w drabince, bo wycofanie się w połowie zostawiałoby przeciwnika bez partii w każdej pozostałej rundzie."
        ]
      },
      "absences": {
        "title": "Nieobecności",
        "body": [
          "To zależy, gdzie byłeś — trzy przypadki kończą się na trzy różne sposoby.",
          "Jeśli jesteś po prostu offline, partia i tak się otwiera, a twój zegar rusza. Przyjść trzy minuty później znaczy grać z trzema minutami mniej, a nie przegrać partię: dopiero jeśli nie przyjdziesz wcale, przegrywasz na czas. Partia, do której jedno z dwojga nigdy nie usiadło, nie rusza rankingu żadnego z nich.",
          "To samo dotyczy sytuacji, gdy się połączysz, a połączenie zerwie się przed twoim pierwszym ruchem: decyduje twój zegar. Po pierwszym ruchu, jeśli się rozłączysz, masz 30 sekund na powrót, jak w każdej partii.",
          "Jeśli natomiast jesteś już zajęty inną partią — areną, wyzwaniem, innym turniejem — partia tej rundy w ogóle się nie otwiera i dostajesz walkower, a 2 punkty idą do przeciwnika. To nie kara: otwarcie ci drugiej szachownicy uczyniłoby tę, na której już grasz, nieosiągalną.",
          "Jeśli nie zjawicie się oboje, runda kończy się 0-0 i nikt nic nie dostaje. Remis urzędowy nagradzałby nieobecność.",
          "W żadnym z trzech przypadków nie wypada się z turnieju: w kolejnej rundzie kojarzy się jak zwykle.",
          "Ostatnia rzecz dotyczy wszystkich: turniej ma zapowiedziany czas trwania, a jeśli o tej godzinie partie wciąż trwają, dostają dziesięć minut. Po tym czasie turniej się zamyka, a partie jeszcze otwarte są uznawane za remisy."
        ]
      },
      "openingMoves": {
        "title": "Ruchy otwarcia",
        "body": [
          "To zależy, jak turniej został otwarty — możliwości jest dziewięć.",
          "«Wolny ruch» to ta zwykła: gra się od pierwszego posunięcia i nikt niczego nie narzuca.",
          "Dalej są losowania. Trzy z nich kładą jedno, dwa albo trzy losowe dozwolone posunięcia i działają w każdym wariancie. Kolejne cztery losują z oficjalnej tabeli F.I.D. i istnieją tylko we włoskim i angielskim, dwóch wariantach mających tabelę federacyjną: wybiera się tam, jak bardzo niezrównoważone może być wylosowane otwarcie — do 1N/1B, do 2N/2B, do 3N/3B albo wszystkie 174. W systemie szwajcarskim to samo otwarcie nie wypada dwa razy w jednym turnieju.",
          "No i jest turniej tematyczny: otwierający wybiera JEDNO z 174 oficjalnych otwarć, a grają je wszyscy, we wszystkich rundach i wszystkich partiach. To jedyny przypadek, w którym otwarcie zna się przed rozpoczęciem, i jedyny, w którym zasada «nigdy dwa razy to samo» nie obowiązuje — byłaby dokładnym przeciwieństwem tego, o co chodzi w turnieju tematycznym.",
          "Przy meczu i rewanżu obie partie rundy gra się na tym samym otwarciu z odwróconymi kolorami: tak niezrównoważone otwarcie przestaje kogokolwiek faworyzować."
        ]
      },
      "rated": {
        "title": "Turnieje rankingowe",
        "body": [
          "Jeśli turniej jest rankingowy, to tak — i nie w osobnej klasyfikacji: partie turniejowe ruszają ten sam ranking co wszystkie inne, ranking danego wariantu i tempa gry. Decyduje o tym otwierający turniej, a domyślnie jest rankingowy.",
          "Turniej lub arena rankingowa mogą mieć minimalny ranking, czyli próg wejścia, stopniami od 1000 do 2000: mierzy się go na twoim rankingu w tym wariancie i tempie, nie na ogólnym. W rozgrywkach towarzyskich progu nie ma, bo ranking się nie rusza i nie ma czego chronić. Górnej granicy nie ma: nikt nie zostaje na zewnątrz dlatego, że jest za silny.",
          "Jest jeszcze coś, co samo z siebie może wyłączyć rankingowość, i jest to otwarcie. Zasada federacyjna mówi, że jedna partia wystarcza, dopóki otwarcie sięga 2N/2B; powyżej przewaga jednego koloru jest za duża, by pojedyncza partia mogła ją zrównoważyć, i potrzebny jest mecz i rewanż. Działa to w obu przypadkach: przy losowaniu liczy się górna granica tabeli, z której się losuje, a w turnieju tematycznym siła wybranego otwarcia, którą tam już się zna. Jeśli zestawienie nie przechodzi, turniej powstaje jako towarzyski zamiast zostać odrzucony — a włączenie meczu i rewanżu przywraca mu rankingowość.",
          "Nie są wreszcie rankingowe partie, do których jedno z dwojga nigdy nie usiadło."
        ]
      },
      "tiebreaks": {
        "title": "Punktacja pomocnicza",
        "body": [
          "To zależy od formatu.",
          "W systemie szwajcarskim, w tej kolejności:",
          "1. Buchholz Cut 1: suma końcowych punktów wszystkich przeciwników, bez najsłabszego. Nagradza trudniejszą drogę. Pauza się nie liczy, bo nie jest przeciwnikiem.",
          "2. Sonneborn-Berger: punkty pokonanych przeciwników plus połowa punktów tych, z którymi był remis. Nagradza tego, kto pokonał silniejszych.",
          "3. Liczba zwycięstw.",
          "4. Zmiana rankingu w turnieju: ile punktów rankingowych zyskałeś lub straciłeś w partiach tego turnieju. Nagradza tego, kto zagrał lepiej, niż się spodziewano, a nie tego, kto już był silniejszy. Kto i tu jest równy, dzieli miejsce.",
          "W tabeli Buchholz i Sonneborn-Berger są po wygranych, remisach, porażkach i pauzach, w skrócie BH i SB.",
          "W systemie kołowym kryteria są inne, bo każdy gra z każdym i Buchholz nikogo by nie rozróżnił: najpierw liczba zwycięstw, potem bezpośredni pojedynek wyłącznie między graczami z tą samą liczbą punktów, potem Sonneborn-Berger (SB), a na końcu zmiana rankingu w turnieju. Jeśli i wtedy jest remis, wyżej jest ten, kto ma lepszy numer w tabeli, czyli wyższy ranking na początku turnieju: w systemie kołowym nie ma miejsc ex aequo. BH nie jest tam pokazywany, bo gdy każdy gra z każdym, jest tylko odwrotnością punktów. W tabeli «BP» oznacza tego, kto jest wyżej dzięki bezpośrednim pojedynkom.",
          "W arenie nie ma rund, więc Buchholza nie dałoby się policzyć: przy równej liczbie punktów decydują liczba zwycięstw, potem bezpośredni pojedynek między równymi punktami, potem średnia punktów napotkanych przeciwników — średnia, a nie suma, bo w arenie każdy rozgrywa bardzo różną liczbę partii — a na końcu ten, kto zdobył te same punkty w mniejszej liczbie partii. W tabeli te dwie liczby pojawiają się tylko w wierszach z remisem punktowym, gdzie są potrzebne: „BP” to bezpośredni pojedynek, „Przeciwnicy” ich średnia."
        ]
      },
      "sharedPlaces": {
        "title": "Miejsca dzielone",
        "body": [
          "W systemie szwajcarskim zdarza się to w małych turniejach, gdy wszystkie partie kończą się remisem: te same punkty, ten sam Buchholz, ten sam Sonneborn-Berger, ani jednego zwycięstwa.",
          "Wtedy miejsce jest dzielone. Dwóch pierwszych ex aequo bierze po złocie, a następne miejsce to trzecie: 1, 1, 3, jak w każdej tabeli sportowej. Nikt nie jest stawiany wyżej z powodu rankingu ani wcześniejszego zapisu.",
          "Jedno zastrzeżenie: w archiwum turnieju zostaje jedno nazwisko zwycięzcy, bo to pole mieści jedno. Tabela i podium pokazują wszystkich ex aequo."
        ]
      },
      "arena": {
        "title": "Arena",
        "body": [
          "Druga rozgrywka, którą można otworzyć, i nie jest to turniej rundowy: nie ma rund ani terminarza, ma czas trwania. Otwiera się, trwa od dziesięciu minut do ośmiu godzin, a dopóki jest otwarta, kojarzy cię na nowo, gdy tylko skończysz, bez czekania, aż inni skończą swoją partię. Wchodzi się i wychodzi, kiedy się chce, także po rozpoczęciu.",
          "Z tą samą osobą jednak się czeka: pięć minut za każdą już wspólnie rozegraną partię. Pierwszy rewanż po pięciu minutach, drugi po dziesięciu, trzeci po piętnastu, i nie ma górnej granicy. Dzięki temu arena nie zamienia się w ten sam pojedynek powtarzany bez końca.",
          "Punktacja: wygrana 2, remis 1, przegrana zero, jak w turnieju.",
          "Jest też boost, do wzięcia przed własnym pierwszym posunięciem: podwaja punkty za wygraną i płaci się za niego zegarem — dodatek znika w całości, a czas bazowy zmniejsza się o połowę. To zakład, nie prezent.",
          "Przy równej liczbie punktów decydują, w tej kolejności: kto wygrał więcej partii; potem bezpośredni pojedynek między tymi, którzy mają też tyle samo zwycięstw; potem siła napotkanych przeciwników, czyli średnia ich punktów — średnia, a nie suma, bo w arenie każdy rozgrywa bardzo różną liczbę partii i suma nagradzałaby tylko tego, kto gra najwięcej; na końcu ten, kto zdobył te same punkty w mniejszej liczbie partii. Partie przerwane się nie liczą, a kto jest równy także na ostatnim kryterium, dzieli miejsce: arena może mieć dwóch zwycięzców."
        ]
      }
    },
    "seo": {
      "title": "{{variant}}: zasady i jak grać",
      "description": "Poznaj zasady wariantu {{variant}}: rozmiar planszy, ustawienie początkowe, jak poruszają się i biją pionki oraz damki, i jak wygrać. Graj w {{draughtsWord}} online za darmo.",
      "indexTitle": "Zasady warcabów — zasady gry i zasady turniejów",
      "indexDescription": "Dwa regulaminy: zasady gry każdego wariantu {{draughtsWord}} — międzynarodowe, włoskie, tureckie, fryzyjskie i inne — oraz zasady naszych turniejów online.",
      "gameTitle": "Zasady warcabów według wariantu — jak grać",
      "gameDescription": "Zasady i poradniki dla każdego wariantu {{draughtsWord}}: międzynarodowe, włoskie, tureckie, fryzyjskie, brazylijskie i wiele innych. Graj online za darmo.",
      "openingsTitle": "{{variant}}: oficjalne tabele otwarć F.I.D.",
      "openingsDescription": "Wszystkie 174 oficjalne otwarcia wariantu {{variant}} z oceną i tabelami związkowymi A, B, C i D. F.I.D. Regolamento Tecnico 2025.",
      "captureTitle": "{{variant}}: pełne zasady bicia",
      "captureDescription": "Wszystkie zasady bicia w {{variant}}: przymus bicia, bicie wielokrotne, hierarchia rozstrzygająca, które bicie wykonać, i awans. Z przykładami na planszy.",
      "tournamentsTitle": "Zasady turniejów — jak działa turniej {{draughtsWord}}",
      "tournamentsDescription": "Zasady turniejów {{draughtsWord}} online: system kołowy/szwajcarski, liczba rund, zapisy i wycofanie, nieobecności, losowanie otwarcia, ranking, punktacja pomocnicza i arena."
    },
    "fact": {
      "board": "Gra się na planszy {{size}}×{{size}}, tylko na ciemnych polach.",
      "boardAllSquares": "Gra się na planszy {{size}}×{{size}}, na wszystkich polach.",
      "pieces": "Każdy gracz zaczyna z {{count}} pionkami.",
      "startsWhite": "Białe zaczynają.",
      "startsBlack": "Czarne zaczynają.",
      "moveDiagonal": "Pionki poruszają się po przekątnej do przodu, o jedno pole.",
      "moveOrthogonal": "Pionki poruszają się ortogonalnie — do przodu i na boki — o jedno pole.",
      "captureDiagonal": "Bicia wykonuje się po przekątnej, przeskakując sąsiedni pionek przeciwnika.",
      "captureOrthogonal": "Bicia wykonuje się ortogonalnie, przeskakując sąsiedni pionek przeciwnika.",
      "captureMixed": "Bicia można wykonywać zarówno po przekątnej, jak i ortogonalnie.",
      "menCaptureBackwardYes": "Pionki mogą bić zarówno do przodu, jak i do tyłu.",
      "menCaptureBackwardNo": "Pionki mogą bić tylko do przodu.",
      "kingFlying": "Damki są \"latające\": poruszają się i biją przez dowolną liczbę pustych pól wzdłuż linii.",
      "kingShort": "Damki poruszają się o jedno pole (bez latających damek).",
      "menCaptureKingYes": "Pionki mogą bić damki.",
      "menCaptureKingNo": "Pionki nie mogą bić damek.",
      "maxCapturePieces": "Bicie jest obowiązkowe i trzeba wykonać sekwencję bijącą najwięcej pionków.",
      "maxCaptureValue": "Bicie jest obowiązkowe i należy wykonać sekwencję o największej wartości: damka jest warta więcej niż pionek, ale dwa pionki są warte więcej niż damka.",
      "captureMandatoryFree": "Bicie jest obowiązkowe, ale można dowolnie wybrać, które wykonać.",
      "kingPriorityTie": "Przy równorzędnych biciach trzeba bić damką, a nie pionkiem.",
      "maxKingsCaptureTie": "Przy równej liczbie pionów należy wykonać sekwencję bijącą najwięcej damek.",
      "firstKingFirst": "Przy dalszej równości trzeba wybrać sekwencję, w której damka lub damki pojawiają się najwcześniej.",
      "huffing": "Obowiązuje zasada \"dmuchania\": pionek, który nie zbił, może zostać zdjęty.",
      "captureImmediateRemoval": "Każdy zbity pionek jest natychmiast zdejmowany z planszy, co może otworzyć kolejne bicia w tej samej sekwencji.",
      "captureNoReversal": "Podczas bicia wielokrotnego można kontynuować prosto lub skręcić o 90°, ale nigdy zawrócić o 180° między dwoma skokami.",
      "promotionStops": "Pionek, który dotrze do ostatniego rzędu, awansuje, a ruch się kończy, nawet w trakcie bicia.",
      "promotionContinues": "Pionek, który podczas bicia przechodzi przez ostatni rząd, pozostaje pionkiem i bije dalej; awansuje tylko wtedy, gdy ruch kończy się na ostatnim rzędzie.",
      "promotionInPassing": "Pionek, który podczas bicia osiągnie ostatni rząd, natychmiast awansuje i bije dalej jako latająca damka w tej samej turze.",
      "blockedKing": "Dopóki gracz ma jeszcze pionki, nie może wykonać więcej niż {{n}} kolejnych zwykłych ruchów tą samą damką; zablokowana damka może jednak bić.",
      "frisianEndgame": "Obowiązują fryzyjskie zasady remisu w końcówce (np. dwie damki przeciw jednej to remis po ustalonej liczbie ruchów).",
      "loneKingWins": "Jeśli graczowi pozostał tylko jeden pionek przeciwko damce przeciwnika, zwycięzcą zostaje strona z damką.",
      "singlePieceLoses": "Gracz, któremu pozostał tylko jeden pionek lub damka, natychmiast przegrywa partię.",
      "drawLimit": "Partia kończy się remisem po {{n}} ruchach, w których ruszają się tylko damki i nic nie zostaje zbite."
    },
    "openings": {
      "title": "Tabele otwarć",
      "heroSubtitle": "174 oficjalne otwarcia wariantu {{variant}} wraz z oceną i tabelą związkową, do której należą.",
      "source": "Źródło: Regolamento Tecnico F.I.D., styczeń 2025.",
      "cta": "Tabele otwarć",
      "ctaDesc": "174 oficjalne otwarcia i ich ocena.",
      "intro": "W oficjalnych zawodach pierwszych trzech półruchów się nie wybiera — są losowane z tabeli. Tabela generalna zawiera wszystkie 174 otwarcia; tabele związkowe A, B, C i D to jej podzbiory, używane zależnie od rodzaju meczu.",
      "ratedNote": "W bezpośrednim wyzwaniu możesz ograniczyć losowanie: do 2N/2B pojedyncza partia liczy się do rankingu, powyżej potrzebny jest mecz i rewanż.",
      "tableAll": "Generalna",
      "tableA": "Tabela A",
      "tableB": "Tabela B",
      "tableC": "Tabela C",
      "tableD": "Tabela D",
      "count": "Otwarcia: {{count}}",
      "colNumber": "Nr",
      "colOpening": "Otwarcie",
      "colStrength": "Ocena",
      "colStrengthShort": "Oc.",
      "colTables": "Tabele",
      "colTablesShort": "Tab.",
      "firstMove": "Pierwszy ruch {{move}}",
      "legendTitle": "Jak czytać ocenę",
      "legendColours": "N = czarne (Nero), B = białe (Bianco).",
      "legendPari": "PARI — gra wyrównana.",
      "legend1": "1N / 1B — ten kolor stoi nieco lepiej i ma większy wybór.",
      "legend2": "2N / 2B — ten kolor stoi wyraźnie lepiej, przeciwnik broni się.",
      "legend3": "3N / 3B — ten kolor jest groźny: przeciwnik potrzebuje precyzyjnej gry na remis.",
      "legend4": "4N / 4B — ten kolor uchodzi za wygrywający przy obecnej wiedzy.",
      "tablesTitle": "Tabele związkowe",
      "italianA": "Tylko mecze dwupartiowe oraz zawody par i drużyn.",
      "italianB": "Domyślna tabela oficjalnych zawodów; można jej użyć również w jednej partii.",
      "italianC": "Podzbiór B dla kategorii młodzieżowych, prowincjonalnych i turniejów promocyjnych.",
      "italianD": "Otwarcia uznane za wygrywające: tylko mecze dwupartiowe.",
      "englishA": "Tabela zwykle stosowana w meczach dwupartiowych i drużynowych.",
      "englishB": "Turnieje rozgrywane w jednej partii.",
      "englishC": "Podzbiór B na szczególne przypadki przewidziane regulaminem.",
      "englishD": "Otwarcia uznane za wygrywające: tylko mecze dwupartiowe.",
      "tableEvery": "Wszystkie",
      "everyTitle": "Dlaczego z 302 otwarć zostaje 174",
      "everyIntro": "Legalnych otwarć z trzech półruchów jest {{total}}, ale prowadzą tylko do {{positions}} różnych pozycji: tabela generalna wybiera {{listed}} z nich, po jednym na pozycję. Oto co dzieje się z resztą.",
      "status_ballot": "W tabeli",
      "statusBallotDesc": "Do wylosowania: jedno z oficjalnych otwarć.",
      "statusTransposition": "Jak nr {{id}}",
      "statusTranspositionShort": "Przestawienie",
      "statusTranspositionDesc": "Ta sama pozycja końcowa co w otwarciu już ujętym w tabeli, osiągnięta inną kolejnością ruchów: byłaby to ta sama partia pod inną nazwą.",
      "status_material": "Traci pionek",
      "statusMaterialDesc": "Po trzecim półruchu jeden kolor ma o pionek mniej i nie ma odbicia: to dwie kombinacje, które regulamin wyklucza od zawsze.",
      "status_unlisted": "Poza tabelą",
      "statusUnlistedDesc": "Pozycja, której tabela w ogóle nie obejmuje. Nie ma przyczyny mechanicznej: związek wybrał linie warte analizy.",
      "statusDecidedDesc": "Zostają w tabeli, ale tylko na mecze dwupartiowe: uchodzą za wygrane dla faworyzowanego koloru, a więc przegrane dla drugiego.",
      "colPosition": "Pozycja"
    },
    "capture": {
      "cta": "Zasady bicia",
      "ctaDesc": "Hierarchia bić, krok po kroku, z przykładami.",
      "title": "Zasady bicia",
      "heroSubtitle": "Kiedy bicie jest obowiązkowe, które bicie trzeba wykonać i jak się liczy, w {{variant}}.",
      "intro": "Bicie to najściślej uregulowana część gry. Nie wystarczy wiedzieć, jak się bije: trzeba wiedzieć, które bicie jest się zobowiązanym wykonać. Wszystkie zasady są tutaj, dokładnie w kolejności, w jakiej stosuje je gra.",
      "source": "Źródło: Regulamin Techniczny F.I.D., styczeń 2025.",
      "mandatoryTitle": "Bicie jest obowiązkowe",
      "mandatoryBody": "Jeśli w twoim ruchu istnieje choćby jedno bicie, wszystkie spokojne posunięcia znikają: to nie są złe ruchy, one po prostu nie istnieją. Przymus dotyczy całej pozycji, a nie pojedynczego pionka.",
      "mandatoryRejected": "Pomyłka nie jest karana: bicie niezgodne z zasadami zostaje odrzucone, a pozycja pozostaje bez zmian.",
      "geometryTitle": "Jak przebiega bicie",
      "geometryShortKing": "Damka również skacze tylko o jedno pole: pionek przeciwnika musi stać bezpośrednio obok, po przekątnej.",
      "geometryLanding": "Pole za bitym pionkiem musi być wolne. Jeśli jest zajęte, przez jakikolwiek pionek, albo leży poza planszą, takie bicie nie istnieje.",
      "menVsKingTitle": "Pionki i damki",
      "menVsKingWall": "Dla pionka damka przeciwnika jest murem: nie może jej zbić ani przeskoczyć. Damka ustawiona przed grupą bierek czyni je nietykalnymi dla pionków.",
      "menVsKingFree": "Nie ma ograniczeń rangi: każda bierka może bić każdą bierkę.",
      "multiTitle": "Bicie wielokrotne",
      "multiBody": "Jeśli po skoku bierka znów stoi przed bierką do zbicia, musi kontynuować. Zatrzymanie się w połowie nie jest wyborem: niepełna sekwencja nie jest legalnym ruchem.",
      "multiDirection": "Przy każdym skoku można zmienić kierunek. Pionek jednak przechodzi tylko między swoimi dwiema przekątnymi do przodu: w trakcie sekwencji nigdy nie zyskuje bicia do tyłu.",
      "multiNoTwice": "Tej samej bierki przeciwnika nie można przeskoczyć dwa razy w jednej sekwencji. Przez to samo puste pole można natomiast przechodzić dowolnie wiele razy.",
      "ladderTitle": "Hierarchia bić",
      "ladderIntro": "Gdy możliwych bić jest więcej niż jedno, wybór nie należy do ciebie. Gra porównuje je według tych kryteriów, w tej kolejności: do następnego kryterium przechodzi się tylko wtedy, gdy poprzednie pozostawia kilka bić na równi.",
      "ladderWholePosition": "Porównanie obejmuje wszystkie bicia wszystkich twoich bierek. Bierka może więc stać nieruchomo, bo inna ma lepsze bicie.",
      "ladderNoneIntro": "Bicie jest obowiązkowe, ale które bicie wykonać, zależy wyłącznie od ciebie. Nie ma żadnej hierarchii: bicie pojedyncze liczy się tak samo jak wielokrotne i nic nie zmusza do zbicia większej liczby bierek.",
      "levelLabel": "Poziom {{n}}",
      "levelMaxPieces": "Trzeba wykonać bicie, które zbija największą liczbę bierek.",
      "whyMaxPieces": "Liczy się liczba bierek, nie ich wartość: dwa pionki biją jedną damkę.",
      "levelMaxValue": "Trzeba wykonać bicie o najwyższej łącznej wartości.",
      "whyMaxValue": "Damki ważą więcej niż pionki, więc nie zawsze wygrywa najdłuższa sekwencja.",
      "levelWithKing": "Przy równej liczbie bierek trzeba bić damką, a nie pionkiem.",
      "whyWithKing": "Kryterium dotyczy bierki bijącej, nie bitej. Jeśli damka i pionek biją tyle samo bierek, ruch należy do damki, nawet gdy pionek zbiłby cenniejsze bierki.",
      "levelMaxKings": "Przy dalszej równości trzeba wykonać bicie, które zbija najwięcej damek.",
      "whyMaxKings": "Tu liczy się wartość tego, co odbiera się przeciwnikowi. Ponieważ tylko damki mogą bić damki, kryterium to rozróżnia wyłącznie bicia damką.",
      "levelFirstKing": "Przy dalszej równości trzeba wybrać sekwencję, w której damka lub damki pojawiają się najwcześniej.",
      "whyFirstKing": "Patrzy się na kolejność skoków: wygrywa trasa, która napotyka pierwszą damkę przy wcześniejszym skoku; przy równości decyduje druga damka, potem trzecia. Wybór jest dowolny tylko wtedy, gdy damki padają przy tych samych skokach.",
      "levelFree": "Jeśli bicia pozostają równoważne, wybór jest wolny.",
      "whyFree": "Poza tym punktem żadna zasada nie wiąże gracza: dwa bicia identyczne pod każdym kryterium można zagrać dowolnie.",
      "removalTitle": "Kiedy bierki schodzą z planszy",
      "removalEnd": "Zbite bierki pozostają na planszy do końca ruchu i zdejmuje się je wszystkie naraz, gdy sekwencja się zakończy. Dlatego podczas bicia wielokrotnego wciąż widzisz je na swoich miejscach.",
      "removalImmediate": "Zwolnione pole od razu wraca do gry. Przeskakiwanie tej samej bierki dwa razy pozostaje zabronione.",
      "promotionTitle": "Awans kończy bicie",
      "promotionBody": "Jeśli w trakcie sekwencji pionek dotrze do ostatniego rzędu, ruch kończy się w tym miejscu: pionek zostaje damką, a kolej przechodzi na przeciwnika, nawet gdyby z tego pola były możliwe dalsze skoki. Nowa damka rusza dopiero w kolejnym ruchu.",
      "promotionNoExemption": "Awans nie zwalnia z hierarchii: przerwana sekwencja jest porównywana z bierkami, które faktycznie zbiła. Jeśli inne bicie zbija więcej, to awansujące jest nielegalne.",
      "promotionStillAMan": "Na potrzeby hierarchii awansujący pionek nadal liczy się jako pionek: nie zyskuje pierwszeństwa damki.",
      "noHuffingTitle": "Bez dmuchania",
      "noHuffingBody": "Zasada \"dmuchania\" nie obowiązuje: kto nie wykona obowiązkowego bicia, nie traci bierki, po prostu nie może zagrać tego ruchu.",
      "exGeometry": "Białe przeskakują sąsiednią bierkę i lądują tuż za nią.",
      "exMenVsKingWall": "Pionek stoi obok damki przeciwnika i nie może jej zbić: zostaje mu tylko spokojny ruch.",
      "exMenVsKingFree": "Tutaj pionek bije damkę tak samo jak każdą inną bierkę.",
      "exMulti": "Tylko jeden legalny ruch: sekwencję trzeba doprowadzić do końca.",
      "exPromotion": "Białe docierają do ostatniego rzędu, więc ruch kończy się tam, choć została jeszcze bierka do zbicia.",
      "exMaxPieces": "Dwa możliwe bicia: jedno zbija jedną bierkę, drugie dwie. Legalne jest tylko dłuższe.",
      "exMaxValue": "Spośród możliwych bić decyduje łączna wartość zbitych bierek.",
      "exWithKing": "Damka i pionek biją po jednej bierce: ruszyć musi damka.",
      "exMaxKings": "Bić mogą dwie damki: trzeba zabrać damkę przeciwnika, nie pionka.",
      "exFirstKing": "Dwie trasy po dwie bierki, każda z jedną damką: obowiązkowa jest ta, która bije damkę jako pierwszą.",
      "exFree": "Pierwszy skok jest wymuszony, potem bicie się rozwidla: po dwie bierki w każdym wariancie — wybór należy do ciebie.",
      "exFreeNoLadder": "Jedno bicie zbija jedną bierkę, drugie dwie: tutaj oba są legalne.",
      "forced": "Ruch obowiązkowy",
      "choices": "Legalne ruchy",
      "diagramAlt": "Pozycja przykładowa"
    },
    "gameRulesHead": "Zasady gry"
  },
  "faq": {
    "title": "FAQ i Kontakt",
    "intro": "Najczęściej zadawane pytania oraz bezpośredni kanał do zgłaszania problemów, próśb i uwag.",
    "questionsTitle": "Najczęstsze pytania",
    "entries": [
      {
        "id": "install-android",
        "q": "Jak zainstalować aplikację na Androidzie?",
        "a": "Aplikację instalujesz bezpośrednio z przeglądarki — Sklep Play nie jest potrzebny.\n1. Otwórz stronę w Chrome (albo Edge, Samsung Internet).\n2. Dotknij menu ⋮ w prawym górnym rogu.\n3. Wybierz \"Zainstaluj aplikację\" (lub \"Dodaj do ekranu głównego\") i potwierdź.\nCzasami przeglądarka sama pokazuje baner instalacji — z niego też możesz skorzystać. Ikona pojawi się wśród pozostałych aplikacji, a gra otworzy się na pełnym ekranie, bez paska przeglądarki."
      },
      {
        "id": "install-ios",
        "q": "Jak zainstalować aplikację na iPhonie lub iPadzie?",
        "a": "Na iPhonie i iPadzie procedura jest inna i wymaga Safari.\n1. Otwórz stronę w Safari (w innych przeglądarkach opcji może nie być).\n2. Dotknij przycisku Udostępnij (kwadrat ze strzałką w górę): na dole na iPhonie, na górze na iPadzie.\n3. Przewiń listę i wybierz \"Do ekranu głównego\".\n4. Dotknij \"Dodaj\" w prawym górnym rogu.\niOS nigdy nie wyświetla automatycznego monitu o instalacji: bez tych kroków ikona nie powstanie."
      },
      {
        "id": "install-desktop",
        "q": "Czy mogę zainstalować aplikację na komputerze?",
        "a": "Tak, w Chrome lub Edge.\n1. Otwórz stronę.\n2. Kliknij ikonę instalacji po prawej stronie paska adresu albo otwórz menu przeglądarki i wybierz \"Zainstaluj…\".\n3. Potwierdź: aplikacja otworzy się we własnym oknie, bez paska przeglądarki.\nFirefox i Safari na komputerze nie obsługują instalacji — możesz normalnie grać w przeglądarce i dodać stronę do zakładek."
      },
      {
        "id": "login",
        "q": "Nie mogę zalogować się na konto — co robić?",
        "a": "Upewnij się, że e-mail i hasło są poprawne. Jeśli nie pamiętasz hasła, użyj linku \"Nie pamiętam hasła\" na ekranie logowania. Jeżeli problem nadal występuje, wypełnij formularz poniżej i wybierz kategorię \"Problem z logowaniem\"."
      },
      {
        "id": "verify-email",
        "q": "Nie otrzymałem e-maila weryfikacyjnego — jak go ponownie uzyskać?",
        "a": "Otwórz okno logowania, spróbuj zalogować się danymi i kliknij \"Wyślij ponownie e-mail weryfikacyjny\". Sprawdź także folder spam."
      },
      {
        "id": "variant-request",
        "q": "Czy mogę zaproponować nowy wariant warcabów?",
        "a": "Tak! Wypełnij formularz kontaktowy poniżej, wybierz \"Prośba o nowy wariant\" i opisz zasady wariantu, który chciałbyś, abyśmy obsługiwali."
      },
      {
        "id": "rules-wrong",
        "q": "Zasady jednego z wariantów wydają się błędne — jak to zgłosić?",
        "a": "Wypełnij formularz kontaktowy poniżej i wybierz \"Korekta zasad\". Wskaż, którego wariantu dotyczy zgłoszenie, i opisz zasadę do poprawienia, najlepiej z linkiem do oficjalnego źródła (FMJD, FID, WCDF itd.)."
      },
      {
        "id": "delete-account",
        "q": "Jak usunąć konto?",
        "a": "Otwórz ustawienia profilu: znajdziesz tam opcje eksportu danych (RODO/GDPR) oraz trwałego usunięcia konta. Usunięcie jest nieodwracalne."
      }
    ],
    "contactTitle": "Skontaktuj się z nami",
    "contactIntro": "Nie znalazłeś odpowiedzi? Napisz do nas — odpowiemy mailem.",
    "category": {
      "login": "Problem z logowaniem",
      "variant_request": "Prośba o nowy wariant",
      "rules": "Korekta zasad",
      "other": "Inne"
    },
    "fields": {
      "name": "Imię (opcjonalnie)",
      "email": "E-mail",
      "category": "Kategoria",
      "subject": "Temat",
      "message": "Wiadomość"
    },
    "submit": "Wyślij zgłoszenie",
    "success": "Dziękujemy! Twoje zgłoszenie zostało wysłane. Odpowiemy mailem tak szybko, jak to możliwe.",
    "errors": {
      "invalidEmail": "Podaj prawidłowy adres e-mail.",
      "subjectTooShort": "Temat musi mieć co najmniej 3 znaki.",
      "messageTooShort": "Wiadomość musi mieć co najmniej 10 znaków.",
      "rateLimited": "Wysłałeś ostatnio zbyt wiele zgłoszeń. Spróbuj ponownie za godzinę.",
      "submitFailed": "Wysyłanie nie powiodło się. Sprawdź połączenie i spróbuj ponownie."
    }
  },
  "home": {
    "heroTitle": "Warcaby Online",
    "heroTagline": "Platforma do gry w warcaby międzynarodowe, włoskie i angielskie. Graj, rywalizuj w turniejach i wspinaj się w rankingu.",
    "welcome": "Witaj",
    "newGame": "Nowa Gra",
    "chooseMode": "Wybierz tryb gry",
    "startNow": "Graj",
    "vsAI": "Graj z AI",
    "vsAIDesc": "Ćwicz z komputerem",
    "vsOnline": "Graj Online",
    "vsOnlineDesc": "Wyzwij prawdziwych graczy",
    "vsFriends": "Graj z Przyjaciółmi",
    "vsFriendsDesc": "Stwórz lub dołącz do prywatnej gry",
    "createTable": "Stwórz Stół",
    "createTableDesc": "Zaproś przyjaciela do gry",
    "joinTable": "Dołącz do Stołu",
    "joinTableDesc": "Wpisz kod pokoju",
    "enterRoomCode": "Wpisz kod pokoju od przyjaciela",
    "variant": "Wariant",
    "difficulty": "Trudność",
    "timeControl": "Kontrola Czasu",
    "startGame": "Rozpocznij Grę",
    "playersOnline": "graczy online",
    "gamesInProgress": "gier w toku",
    "landing": {
      "heroTitle": "Graj w Warcaby",
      "heroTitleAccent": "Online",
      "heroTagline": "Warianty warcabów z całego świata. Turnieje, gry rankingowe, przeciwnicy AI — graj teraz.",
      "playFree": "Graj Teraz",
      "signUp": "Zarejestruj się",
      "playAsGuest": "Graj jako Gość",
      "featuresLabel": "Dlaczego Warcaby?",
      "featuresTitle": "Wszystko czego potrzebujesz do gry",
      "featuresSubtitle": "Kompletna platforma dla graczy turniejowych i rekreacyjnych.",
      "featureTournaments": "Turnieje",
      "featureTournamentsDesc": "Formaty Swiss i Arena z automatycznym parowaniem, rankingiem Glicko-2 i tabelami na żywo.",
      "featureRating": "System Rankingowy",
      "featureRatingDesc": "Oddzielne rankingi Glicko-2 dla wariantów i kontroli czasu. Śledź swoje postępy.",
      "featureAI": "Przeciwnicy AI",
      "featureAIDesc": "6 poziomów trudności od początkującego do eksperta. Ćwicz w dowolnym momencie.",
      "featureVariants": "Warianty Świata",
      "featureVariantsDesc": "Od międzynarodowych i włoskich po tureckie, fryzyjskie i więcej — warianty warcabów z całego świata.",
      "featureOnline": "Gra online",
      "featureOnlineDesc": "Znajdź przeciwnika w kilka sekund dzięki matchmakingowi i graj partie rankingowe lub towarzyskie.",
      "featurePuzzles": "Codzienne zadania",
      "featurePuzzlesDesc": "Nowe zadanie każdego dnia w kilku wariantach. Wyostrz taktykę i podnoś swój ranking.",
      "specBoard": "Plansza {{size}}",
      "specPieces": "{{count}} bierek na stronę",
      "specFlyingKings": "Latające damki",
      "specShortKings": "Krótkie damki",
      "howLabel": "Jak?",
      "howTitle": "Zacznij grać w kilka sekund",
      "step1Title": "Utwórz Konto",
      "step1Desc": "Zarejestruj się w kilka sekund. Lub graj natychmiast jako gość.",
      "step2Title": "Wybierz Grę",
      "step2Desc": "Wybierz wariant, kontrolę czasu i graj przeciwko ludziom lub AI.",
      "step3Title": "Wspinaj się w Rankingu",
      "step3Desc": "Wygrywaj gry, zdobywaj punkty rankingowe i bierz udział w codziennych turniejach.",
      "variantsLabel": "Warianty Gry",
      "variantsTitle": "Każdy wariant warcabów, jedna platforma",
      "variantsMoreTitle": "I wiele więcej wariantów",
      "variantsAllCta": "Zobacz zasady każdego wariantu",
      "intlBadge": "FMJD Oficjalne",
      "intlDesc": "Standard warcabów turniejowych na świecie. Latające damki, obowiązkowe bicia i zasada najdłuższego bicia.",
      "italianBadge": "Tradycyjne",
      "italianDesc": "Ukochana tradycja włoska. Pionki nie mogą bić damek, a zasada największej liczby zbitych pionków tworzy głęboką grę taktyczną.",
      "englishBadge": "WCDF Oficjalne",
      "englishDesc": "Klasyczne warcaby 8×8 grane na całym świecie. Obowiązkowe bicie, damki nie latające, pionki mogą bić damki i brak ruchu do tyłu dla pionków.",
      "brazilianBadge": "Popularne",
      "brazilianDesc": "Ulubiona odmiana warcabów w Brazylii. Plansza 8×8 z latającymi damkami, obowiązkowe najdłuższe bicie i pionki bijące do tyłu.",
      "ctaTitle": "Gotowy do gry?",
      "ctaSubtitle": "Dołącz do społeczności. Rozpocznij swoją pierwszą grę.",
      "ctaButton": "Zacznij Grać Teraz",
      "heroCta": "Graj teraz",
      "puzzleTitle": "Spróbuj zagadki",
      "puzzleSubtitle": "Rozwiąż tę pozycję od razu, bez rejestracji. Potem załóż darmowe konto, aby grać w zagadkę dnia i podnosić swój ranking."
    },
    "dashboard": {
      "welcomeBack": "Witaj ponownie",
      "recentGames": "Ostatnie Gry",
      "viewAll": "Zobacz Wszystko",
      "liveUpcoming": "Na Żywo i Nadchodzące",
      "allTournaments": "Wszystkie Turnieje",
      "thisWeek": "ten tydzień",
      "live": "NA ŻYWO",
      "join": "Dołącz",
      "noRecentGames": "Brak gier. Zagraj swoją pierwszą!",
      "noTournaments": "Brak nadchodzących turniejów.",
      "timeAgo": {
        "now": "przed chwilą",
        "minutes": "{{count}} min temu",
        "hours": "{{count}}h temu",
        "yesterday": "Wczoraj",
        "days": "{{count}}d temu",
        "weeks": "{{count}}t temu",
        "months": "{{count}}m temu"
      },
      "dailyPuzzle": {
        "title": "Zagadka dnia",
        "whiteToMove": "Ruch białych",
        "blackToMove": "Ruch czarnych"
      }
    }
  },
  "game": {
    "header": {
      "rated": "Rankingowa",
      "casual": "Towarzyska",
      "variantRules": "Zasady wariantu"
    },
    "variants": {
      "international": "Warcaby Międzynarodowe 10×10",
      "internationalShort": "Międzynarodowe 10×10",
      "internationalMedium": "Międzynarodowe 10×10",
      "italian": "Warcaby Włoskie 8×8",
      "italianShort": "Włoskie 8×8",
      "english": "Warcaby Angielskie 8×8",
      "englishShort": "Angielskie 8×8",
      "englishBadge": "WCDF Oficjalne",
      "englishDesc": "Klasyczne warcaby 8×8 grane na całym świecie. Obowiązkowe bicie, damki nie latające, pionki mogą bić damki i brak ruchu do tyłu dla pionków.",
      "brazilian": "Warcaby Brazylijskie 8×8",
      "brazilianShort": "Brazylijskie 8×8",
      "frisian": "Warcaby Fryzyjskie 10×10",
      "frisianShort": "Fryzyjskie 10×10",
      "frysk": "Frysk! 10×10",
      "fryskShort": "Frysk 10×10",
      "turkish": "Warcaby Tureckie 8×8",
      "turkishShort": "Tureckie 8×8",
      "armenian": "Ormiańska Tama 8×8",
      "armenianShort": "Ormiańskie 8×8",
      "russian": "Warcaby Rosyjskie 8×8",
      "russianShort": "Rosyjskie 8×8",
      "spanish": "Warcaby Hiszpańskie 8×8",
      "spanishShort": "Hiszpańskie 8×8",
      "triestine": "Warcaby Triesteńskie 10×10",
      "triestineShort": "Triesteńskie 10×10",
      "canadian": "Warcaby Kanadyjskie 12×12",
      "canadianShort": "Kanadyjskie 12×12",
      "nigerian": "Warcaby Nigeryjskie 10×10",
      "nigerianShort": "Nigeryjskie 10×10",
      "ghanaian": "Warcaby Ghańskie 10×10",
      "ghanaianShort": "Ghańskie 10×10",
      "pool": "Pool Checkers 8×8",
      "poolShort": "Pool 8×8",
      "czech": "Warcaby Czeskie 8×8",
      "czechShort": "Czeskie 8×8",
      "thai": "Tajski Makhos 8×8",
      "thaiShort": "Tajskie 8×8",
      "portuguese": "Warcaby Portugalskie 8×8",
      "portugueseShort": "Portugalskie 8×8",
      "filipino": "Warcaby Filipińskie 8×8",
      "filipinoShort": "Filipińskie 8×8",
      "malaysian": "Warcaby Malezyjskie 12×12",
      "malaysianShort": "Malezyjskie 12×12",
      "german": "Damenspiel Niemieckie 8×8",
      "germanShort": "Niemieckie 8×8",
      "jamaican": "Warcaby Jamajskie 8×8",
      "jamaicanShort": "Jamajskie 8×8",
      "sinhalese": "Warcaby Syngaleskie 8×8",
      "sinhaleseShort": "Syngaleskie 8×8",
      "south_african": "Warcaby Południowoafrykańskie 14×14",
      "south_africanShort": "Połudn.-Afryk. 14×14",
      "dameo": "Dameo 8×8",
      "dameoShort": "Dameo 8×8",
      "croda": "Croda 8×8",
      "crodaShort": "Croda 8×8"
    },
    "opponent": {
      "computer": "AI"
    },
    "modes": {
      "twoPlayers": "2 Graczy",
      "aiVeryEasy": "Bardzo Łatwy",
      "aiEasy": "Łatwy",
      "aiMedium": "Średni",
      "aiHard": "Trudny",
      "aiExpert": "Bardzo Trudny",
      "aiMaster": "Ekspert",
      "playOnline": "Graj Online"
    },
    "timeControls": {
      "noTimeLimit": "Bez Limitu Czasu",
      "blitz30": "Blitz 3+0",
      "blitz32": "Blitz 3+2",
      "blitz50": "Blitz 5+0",
      "blitz53": "Blitz 5+3",
      "rapid105": "Rapid 10+5",
      "rapid1510": "Rapid 15+10"
    },
    "turn": {
      "yourTurn": "Twój ruch",
      "opponentTurn": "Ruch przeciwnika",
      "toMove": "Rusza",
      "aiThinking": "AI myśli...",
      "aiTurn": "Ruch AI",
      "aiDeclinedDraw": "Komputer odrzucił remis",
      "whiteToMove": "Ruch białych",
      "blackToMove": "Ruch czarnych"
    },
    "result": {
      "youWin": "Wygrywasz!",
      "youLose": "Przegrywasz!",
      "draw": "Remis!",
      "whiteWins": "Białe Wygrywają!",
      "blackWins": "Czarne Wygrywają!",
      "gameOver": "Koniec Gry",
      "gameAbandoned": "Gra Przerwana",
      "noWinner": "Partia przerwana",
      "won": "Wygrana",
      "lost": "Przegrana"
    },
    "drawCountdown": {
      "aria_one": "Automatyczny remis za {{count}} ruch, jeśli ruszają się tylko damki",
      "aria_few": "Automatyczny remis za {{count}} ruchy, jeśli ruszają się tylko damki",
      "aria_many": "Automatyczny remis za {{count}} ruchów, jeśli ruszają się tylko damki",
      "aria_other": "Automatyczny remis za {{count}} ruchów, jeśli ruszają się tylko damki"
    },
    "frisianCountdown": {
      "aria_one": "Automatyczny remis za {{count}} ruch: dwie damki przeciw jednej",
      "aria_few": "Automatyczny remis za {{count}} ruchy: dwie damki przeciw jednej",
      "aria_many": "Automatyczny remis za {{count}} ruchów: dwie damki przeciw jednej",
      "aria_other": "Automatyczny remis za {{count}} ruchów: dwie damki przeciw jednej"
    },
    "endReason": {
      "checkmate": "brak ruchów",
      "noLegalMoves": "nie ma więcej legalnych ruchów.",
      "whiteNoMoves": "Białe nie mają więcej legalnych ruchów.",
      "blackNoMoves": "Czarne nie mają więcej legalnych ruchów.",
      "drawEnded": "Gra zakończyła się remisem.",
      "gameAbandoned": "Gra została przerwana.",
      "noWinner": "Partia zakończyła się bez zwycięzcy.",
      "gameEnded": "Gra się zakończyła.",
      "resignation": "poddanie",
      "disconnection": "rozłączenie",
      "fiftyMoves": "50 ruchów",
      "timeout": "czas minął",
      "agreement": "remis za porozumieniem",
      "walkover": "walkower",
      "firstKing": "Pierwsza damka",
      "sideResigned": "{{side}} poddał partię.",
      "sideTimeout": "{{side}} przekroczył czas.",
      "sideNoPieces": "{{side}} nie ma już pionów.",
      "moveLimit": "Zbyt wiele ruchów bez bicia.",
      "repetition": "Ta sama pozycja powtórzona trzy razy.",
      "endgameDraw": "Końcówka teoretycznie remisowa.",
      "sideZugzwang": "{{side}} jest w zugzwangu: każdy ruch przegrywa.",
      "loneKing": "Samotna damka wygrywa z samotnym pionem.",
      "sideSinglePiece": "{{side}} został z jednym pionem.",
      "drawAgreed": "Remis za zgodą stron.",
      "sideNoFirstMove": "{{side}} nie wykonał ruchu na czas.",
      "noFirstMove": "Pierwszy ruch nie został wykonany na czas."
    },
    "actions": {
      "newGame": "Nowa Gra",
      "resign": "Poddaj się",
      "endGame": "Zakończ",
      "leaveGame": "Opuść Grę",
      "backToLobby": "Powrót do Lobby",
      "offerDraw": "Remis",
      "drawOffered": "Przeciwnik proponuje remis",
      "drawSent": "Remis zaproponowany…",
      "acceptDraw": "Akceptuj",
      "declineDraw": "Odrzuć",
      "drawDeclined": "Przeciwnik odrzucił propozycję remisu",
      "drawMoveFirst": "Najpierw ruch",
      "drawMustMoveFirst": "Wykonaj ruch, zanim ponownie zaproponujesz remis.",
      "drawNoneLeft": "Brak propozycji",
      "drawLimitReached": "Wykorzystałeś wszystkie propozycje remisu w tej partii.",
      "drawTooFast": "Zbyt wiele propozycji remisu. Odczekaj chwilę.",
      "requestTakeback": "Cofnij ruch",
      "takebackRequested": "Wysłano prośbę o cofnięcie…",
      "opponentRequestsTakeback_one": "Przeciwnik prosi o cofnięcie {{count}} ruchu",
      "opponentRequestsTakeback_few": "Przeciwnik prosi o cofnięcie {{count}} ruchów",
      "opponentRequestsTakeback_many": "Przeciwnik prosi o cofnięcie {{count}} ruchów",
      "opponentRequestsTakeback_other": "Przeciwnik prosi o cofnięcie {{count}} ruchów",
      "acceptTakeback": "Akceptuj",
      "declineTakeback": "Odrzuć",
      "takebackDeclined": "Twoja prośba o cofnięcie została odrzucona",
      "takebackAccepted": "Twoja prośba o cofnięcie została zaakceptowana",
      "takebackDisabledRated": "Cofanie ruchu jest wyłączone w grach rankingowych",
      "focus": "Skupienie",
      "focusExit": "Wyjdź",
      "peek": "Zerknij",
      "boardSize": "Rozmiar planszy",
      "boardBigger": "Większa plansza",
      "boardSmaller": "Mniejsza plansza",
      "flipBoard": "Obróć"
    },
    "confirmLeave": "Czy na pewno chcesz opuścić grę?",
    "confirmLeaveTitle": "Opuścić grę?",
    "confirmLeaveCancel": "Anuluj",
    "confirmLeaveButton": "Opuść",
    "confirmResignTitle": "Poddać się?",
    "confirmResign": "Czy na pewno chcesz się poddać? Przegrasz partię.",
    "confirmEndGameTitle": "Zakończyć partię?",
    "confirmEndGame": "Partia zakończy się bez zwycięzcy.",
    "clock": {
      "white": "Białe",
      "black": "Czarne"
    },
    "aborted": {
      "opponentLeft": "Przeciwnik wyszedł przed rozpoczęciem partii — szukamy nowego przeciwnika…",
      "opponentDidNotMove": "Przeciwnik nie wykonał ruchu na czas — partia anulowana."
    },
    "disconnection": {
      "opponentDisconnected": "Przeciwnik Rozłączony",
      "waitingToReconnect": "Oczekiwanie na ponowne połączenie przeciwnika...",
      "opponentLeft": "Przeciwnik opuścił grę",
      "disconnected": "Rozłączony",
      "notPresent": "Nieobecny",
      "avvisoMaiArrivato": "Przeciwnik jeszcze nie dołączył: jeśli nie dołączy, wygrywasz, gdy skończy mu się czas.",
      "avvisoDecideOrologio": "Przeciwnik rozłączony: jeśli nie wróci, wygrywasz, gdy skończy mu się czas.",
      "avvisoGrazia": "Przeciwnik rozłączony: jeśli nie wróci w ciągu {{secondi}} s, wygrywasz.",
      "avvisoMaiArrivatoTuoTurno": "Przeciwnik jeszcze nie dołączył: wykonaj ruch; jeśli nie dołączy, wygrywasz, gdy skończy mu się czas.",
      "avvisoDecideOrologioTuoTurno": "Przeciwnik rozłączony: wykonaj ruch; jeśli nie wróci, wygrywasz, gdy skończy mu się czas."
    },
    "sidebar": {
      "moves": "Ruchy",
      "openingNumbered": "Otwarcie nr {{n}}",
      "openingDrawn": "Wylosowane otwarcie",
      "chat": "Czat",
      "spectators": "Widzowie",
      "noMoves": "Brak ruchów",
      "viewMove": "Zobacz pozycję po ruchu {{n}}",
      "goToStart": "Idź na początek",
      "prevMove": "Poprzedni ruch",
      "nextMove": "Następny ruch",
      "goLive": "Przejdź do bieżącej pozycji",
      "play": "Odtwórz",
      "pause": "Pauza",
      "position": "Pozycja w wariancie",
      "showMoves": "Pokaż ruchy",
      "hideMoves": "Ukryj ruchy"
    },
    "blind": {
      "lastMove": "Ostatni ruch",
      "promoted": "Damka",
      "noPeeks": "Partia rozegrana bez ani jednego zerknięcia.",
      "peeks_one": "Zerknąłeś {{count}} raz.",
      "peeks_few": "Zerknąłeś {{count}} razy.",
      "peeks_many": "Zerknąłeś {{count}} razy.",
      "peeks_other": "Zerknąłeś {{count}} razy."
    },
    "confirmDrawTitle": "Remis?",
    "confirmDraw": "Zakończyć partię remisem? Obaj gracze muszą się zgodzić.",
    "match": {
      "playReturn": "Zagraj rewanż"
    },
    "primaMossa": {
      "secondi_one": "{{count}}s",
      "secondi_other": "{{count}}s",
      "ariaVoid_one": "Pierwszy ruch w ciągu {{count}} sekundy, inaczej partia zostanie anulowana",
      "ariaVoid_other": "Pierwszy ruch w ciągu {{count}} sekund, inaczej partia zostanie anulowana",
      "ariaForfeit_one": "Pierwszy ruch w ciągu {{count}} sekundy, inaczej przegrywasz walkowerem",
      "ariaForfeit_other": "Pierwszy ruch w ciągu {{count}} sekund, inaczej przegrywasz walkowerem"
    },
    "saluto": {
      "invia": "Życz przeciwnikowi dobrej gry",
      "mittente": "{{username}}:",
      "ancheATe": "Tobie też",
      "inviato": "Przywitanie wysłane"
    }
  },
  "online": {
    "title": "Gra Online",
    "playOnline": "Graj Online",
    "connecting": "Łączenie z serwerem...",
    "connectionFailed": "Połączenie Nieudane",
    "couldNotConnect": "Nie można połączyć się z serwerem gry.",
    "error": "Błąd",
    "room": {
      "title": "Pokój",
      "code": "Kod pokoju",
      "shareCode": "Udostępnij ten kod pokoju:",
      "playAs": "Grasz jako",
      "waitingForOpponent": "Oczekiwanie na Przeciwnika"
    },
    "lobby": {
      "findMatch": "Znajdź Mecz",
      "matchmakingByRating": "Automatyczne dopasowanie według ratingu",
      "signInToMatch": "Zaloguj się, aby korzystać z automatycznego dopasowania z ratingiem",
      "createGame": "Utwórz Grę",
      "selectVariantAndTime": "Wybierz wariant i kontrolę czasu",
      "createRoom": "Utwórz Pokój",
      "joinGame": "Dołącz do Gry",
      "enterRoomCode": "Wprowadź kod pokoju, aby dołączyć",
      "join": "Dołącz",
      "playWithFriends": "lub graj z przyjaciółmi"
    },
    "matchmaking": {
      "findingOpponent": "Szukanie Przeciwnika...",
      "matchingSimilarSkill": "Dopasowujemy gracza o podobnym poziomie...",
      "creatingRoom": "Tworzenie pokoju...",
      "joiningRoom": "Dołączanie do pokoju...",
      "estimatedWait": "Szacowany czas oczekiwania: ~{{seconds}}s",
      "timeout": "Nie znaleziono przeciwnika. Spróbuj ponownie."
    },
    "errors": {
      "authRequired": "Musisz się zalogować, aby grać online.",
      "alreadyInQueue": "Już szukasz meczu.",
      "alreadyInGame": "Już jesteś w grze.",
      "generico": "Coś poszło nie tak. Spróbuj ponownie.",
      "nonConnesso": "Nie masz połączenia z serwerem.",
      "partitaSparita": "Ta partia już nie istnieje.",
      "drawOfferFailed": "Nie udało się zaproponować remisu.",
      "serverRestart": "Serwer się restartuje: partia wróci za chwilę. Jeśli nie wróci, odśwież stronę.",
      "sfidaTroppeRichieste": "Wysłałeś zbyt wiele wyzwań z rzędu. Poczekaj chwilę.",
      "avversarioOffline": "Ten gracz się rozłączył.",
      "avversarioInPartita": "Ten gracz już gra. Spróbuj, gdy skończy.",
      "seiInGara": "Bierzesz udział w trwającym turnieju lub arenie: najpierw dokończ to.",
      "avversarioInGara": "Ten gracz gra w turnieju lub na arenie.",
      "troppePosizioni": "Zbyt wiele własnych pozycji z rzędu. Poczekaj chwilę.",
      "impostazioniNonValide": "Te ustawienia są nieprawidłowe. Sprawdź je i spróbuj ponownie.",
      "soloIscritti": "Ten gracz może grać tylko partie towarzyskie.",
      "avversarioNonDisturbare": "Ten gracz nie przyjmuje wyzwań. Spróbuj ponownie później.",
      "sfidaGiaInVolo": "Masz już wyzwanie czekające na odpowiedź. Najpierw je anuluj.",
      "sfidaGiaMandata": "Już wyzwałeś tego gracza: poczekaj na odpowiedź."
    },
    "challenge": {
      "challenge": "Wyzwij",
      "sendChallenge": "Bezpośrednie wyzwanie",
      "incomingChallenge": "Przychodzące Wyzwanie",
      "tabBadge": "Wyzwanie!",
      "send": "Wyślij",
      "accept": "Akceptuj",
      "decline": "Odrzuć",
      "cancel": "Anuluj",
      "loginRequired": "Zaloguj się, aby zobaczyć graczy online i wysyłać wyzwania",
      "waitingForResponse": "Oczekiwanie na {{username}}...",
      "declined": "Wyzwanie odrzucone",
      "expired": "Wyzwanie wygasło",
      "cancelled": "Wyzwanie anulowane",
      "color": "Kolor",
      "gameType": "Typ gry",
      "colorRandom": "Losowy",
      "rated": "Rankingowa (bez gości)",
      "casual": "Towarzyska",
      "gameTypeAny": "Rankingowa/Towarzyska",
      "registeredOnly": "Tylko zarejestrowani",
      "registeredOnlyNote": "W tę partię mogą zagrać tylko zarejestrowani gracze.",
      "opponentGuestNoRated": "Ten przeciwnik jest gościem: partia nie może być rankingowa.",
      "mode": "Tryb",
      "modeNormal": "Standardowy",
      "modeBreakthrough": "Breakthrough",
      "modeAntidraughts": "Antywarcaby",
      "modeBlind": "Na ślepo",
      "modeInfoLabel": "O trybach gry",
      "modeBreakthroughInfo": "Wygrywa ten, kto pierwszy awansuje pionek na damkę.",
      "modeAntidraughtsInfo": "Odwrócony cel: wygrywa ten, kto zostanie bez bierek lub bez legalnego ruchu.",
      "modeBlindInfo": "Pionki są niewidoczne: grasz z pamięci, jak z zawiązanymi oczami. Zasady pozostają zwykłe.",
      "opening": "Otwarcie",
      "legs": "Partie",
      "legsOne": "Tylko pierwsza",
      "legsTwo": "Mecz i rewanż",
      "openingDrawnSingleLegCasual": "Przy tym otwarciu jedna partia nie rekompensuje przewagi z losowania: partia jest zawsze towarzyska.",
      "time": "Czas",
      "increment": "Inkrement",
      "noClockCasual": "Partie bez limitu czasu są zawsze towarzyskie.",
      "link": {
        "inviteFriend": "Zaproś znajomego",
        "title": "Wyzwij znajomego",
        "intro": "Wyślij ten link komukolwiek: kto otworzy go pierwszy, zagra z tobą — nawet bez konta.",
        "share": "Udostępnij",
        "copy": "Kopiuj link",
        "copied": "Skopiowano!",
        "copyFailed": "Nie udało się skopiować linku. Zaznacz go i skopiuj ręcznie.",
        "expiresIn": "Link jest ważny jeszcze {{time}}.",
        "startingSoon": "Partia zaraz się zacznie...",
        "friendAccepted": "{{name}} przyjął(-ęła) wyzwanie!",
        "cancelLink": "Anuluj wyzwanie",
        "shareTitle": "Wyzwanie w warcaby",
        "shareText": "Zagraj ze mną w warcaby!",
        "shareTextWith": "Zagraj ze mną w warcaby — {{summary}}",
        "challengesYou": "{{name}} wyzywa cię na partię warcabów",
        "playNow": "Zagraj teraz",
        "haveAccount": "Mam już konto",
        "guestCasualNote": "Gra jako gość jest towarzyska (nie wpływa na ranking).",
        "waitingChallengerTitle": "Wyzwanie przyjęte",
        "waitingChallenger": "Czekamy, aż {{name}} wróci online. Partia zacznie się sama.",
        "unavailableTitle": "Wyzwanie niedostępne",
        "cancelledByChallenger": "Gracz, który cię wyzwał, anulował partię.",
        "expiredOrGone": "Ten link wygasł lub jest już nieważny. Poproś znajomego o nowy.",
        "backHome": "Powrót do strony głównej"
      },
      "opening_free": "Wolny ruch",
      "opening_random1": "1 dowolny losowy ruch",
      "opening_random2": "2 dowolne losowe ruchy",
      "opening_random3": "3 dowolne losowe ruchy",
      "opening_ballot1": "Tabela C - 1N/1B",
      "opening_ballot2": "Tabela B - 2N/2B",
      "opening_ballot3": "Tabela {{tables}} - 3N/3B",
      "opening_ballot4": "Tabela ogólna",
      "opening_single": "Stałe otwarcie",
      "openingInfoLabel": "O otwarciach",
      "openingInfo": "Pozycje „Tabela” losują z oficjalnych tabel F.I.D.: liczba w nawiasie mówi, z ilu otwarć odbywa się losowanie, a próg (1N/1B … 4N/4B) ogranicza, jak nierówne może być otwarcie. Do Tabeli B pojedyncza partia nadal liczy się do rankingu; powyżej potrzebny jest mecz i rewanż. Pozycje „losowe ruchy” losują natomiast spośród wszystkich legalnych ruchów, zupełnie bez progu: od 2 ruchów wzwyż wymagają meczu i rewanżu.",
      "openingInfoRandom": "Pierwsze półruchy są losowane spośród wszystkich legalnych: liczba w nawiasie mówi, ile różnych kombinacji może wypaść. Ten wariant nie ma oficjalnych tabel otwarć. Od 2 ruchów wzwyż losowanie może faworyzować jeden kolor, więc partia liczy się do rankingu tylko jako mecz i rewanż.",
      "openingTablesLink": "Zobacz tabele otwarć",
      "guestCannotChallenge": "Bezpośrednie wyzwania są dla zarejestrowanych graczy. Zaloguj się lub załóż darmowe konto, aby je wysyłać.",
      "guestCasualInvite": "Zaloguj się lub załóż darmowe konto, aby grać partie rankingowe.",
      "changeOpponent": "Zmień",
      "challengePlayer": "Wyzwij {{username}}",
      "tableOpen": {
        "title": "{{username}} ma już otwarty stół",
        "other": "Wyślij inne wyzwanie"
      }
    },
    "status": {
      "playing": "W grze",
      "playingWith": "Gra z {{username}}",
      "waiting": "Oczekuje",
      "away": "Nieobecny",
      "busy": "Zajęty"
    },
    "chooseOpponent": "Wybierz przeciwnika",
    "ratingsBucket": "Rankingi:",
    "onlinePlayers": "Gracze online",
    "loadingPlayers": "Ładowanie graczy...",
    "noPlayersOnline": "Nikogo innego teraz nie ma",
    "reloadIn": "Odświeżenie za {{seconds}} s",
    "reloadInShort": "{{seconds}} s",
    "rematch": {
      "rematch": "Rewanż",
      "accept": "Akceptuj",
      "decline": "Odrzuć",
      "sessionScore": "Wynik",
      "opponentWantsRematch": "Przeciwnik chce rewanżu!",
      "declined": "Przeciwnik odrzucił rewanż",
      "expired": "Propozycja rewanżu wygasła",
      "invite": {
        "incoming": "Zaproszenie do rewanżu",
        "tabBadge": "Rewanż!",
        "message": "<b>{{name}}</b> ({{rating}}) chce rewanżu · <b>{{timeControl}}</b> · {{variant}}",
        "messageNoRating": "<b>{{name}}</b> chce rewanżu · <b>{{timeControl}}</b> · {{variant}}"
      },
      "waitingForOpponent": "Oczekiwanie na przeciwnika...",
      "newOpponent": "Wróć do strony głównej"
    },
    "match": {
      "legFirst": "Pierwszy mecz",
      "legSecond": "Rewanż",
      "legOf": "Partia {{leg}} z {{total}}",
      "legShort": "{{leg}}/{{total}}",
      "score": "Mecz",
      "returnStartsIn": "Rewanż zaczyna się za {{seconds}}s",
      "leavingForfeits": "Jeśli teraz wyjdziesz, przegrywasz rewanż walkowerem.",
      "ratingAtMatchEnd": "Ranking aktualizuje się na koniec meczu.",
      "ready": "Gotowy",
      "opponentReady": "Przeciwnik jest gotowy",
      "waitingOpponent": "Czekanie na przeciwnika...",
      "complete": "Mecz zakończony",
      "newMatch": "Nowy mecz",
      "twoLegsShort": "2 partie"
    },
    "connectedCount": "{{count}} Online",
    "viewProfile": "Profil",
    "connessionePersa": {
      "titolo": "Utracono połączenie",
      "corpo": "Próbujemy przywrócić cię do partii.",
      "riprova": "Spróbuj ponownie",
      "esci": "Wyjdź"
    },
    "partitaFinitaMentreEriVia": "Partia zakończyła się, gdy cię nie było.",
    "sessioneAltrove": {
      "titolo": "Otwarte na innym urządzeniu",
      "corpo": "Gra została otwarta gdzie indziej: tutaj nie otrzymasz już ruchów ani wyzwań.",
      "usaQui": "Użyj tutaj"
    }
  },
  "lobby": {
    "title": "Graj",
    "quickPlay": "Szybka gra",
    "customGame": "Gra na własnych zasadach",
    "opponent": "Przeciwnik",
    "opponentOnline": "Online (losowy)",
    "opponentInPerson": "Na żywo",
    "startInPerson": "Rozpocznij partię",
    "inPersonNote": "Dwoje graczy na tym samym urządzeniu. Nie liczy się do rankingu.",
    "openTable": "Otwórz stolik",
    "openTables": "Stoliki w kolejce",
    "noTablesInVariant": "Nie ma teraz stolika w wariancie {{variant}}. Wybierz tempo, aby otworzyć własny.",
    "noTablesInVariantOrOther": "Nie ma teraz stolika w wariancie {{variant}}. Wybierz tempo, aby otworzyć własny, albo usiądź przy stoliku w innym wariancie:",
    "otherVariants": "Inne warianty",
    "sit": "Usiądź",
    "cancelTable": "Anuluj",
    "waitingAtTable": "Czekam na przeciwnika",
    "inQueue": "W kolejce",
    "tableExpired": "Twój stół wygasł po 10 minutach bez przeciwnika. Otwórz nowy, kiedy chcesz.",
    "customPosition": "Własna pozycja",
    "errors": {
      "inCompetition": "Najpierw opuść arenę lub turniej.",
      "rateLimited": "Za dużo stolików. Poczekaj chwilę.",
      "tableGone": "Ten stolik jest już niedostępny.",
      "hostGone": "Gracza, który otworzył ten stół, już nie ma.",
      "ownTable": "To jest Twój stolik.",
      "invalidSettings": "Te ustawienia są nieprawidłowe.",
      "startFailed": "Nie udało się rozpocząć partii. Spróbuj ponownie.",
      "generic": "Coś poszło nie tak. Spróbuj ponownie."
    }
  },
  "spectate": {
    "watch": "Obserwuj",
    "watchPlayer": "Obserwuj partię gracza {{username}}",
    "watchPair": "Obejrzyj {{a}} przeciw {{b}}",
    "watching": "Obserwujesz",
    "leave": "Wyjdź",
    "loading": "Wczytywanie partii...",
    "turnWhite": "Ruch białych",
    "turnBlack": "Ruch czarnych",
    "whiteWins": "Wygrywają białe",
    "blackWins": "Wygrywają czarne",
    "draw": "Remis",
    "gameOver": "Koniec partii",
    "betweenLegs": "Pierwszy mecz zakończony: rewanż zaraz się zacznie",
    "unavailable": "Ta partia nie jest już dostępna",
    "error": {
      "notPlaying": "Ten gracz nie gra już partii.",
      "unavailable": "Ta partia nie jest już dostępna.",
      "busy": "Nie możesz obserwować partii, gdy sam grasz.",
      "self": "To twoja własna partia — otwórz ją ze swojej szachownicy."
    },
    "watchers": {
      "empty": "Nikt teraz nie ogląda."
    }
  },
  "auth": {
    "signIn": "Zaloguj się",
    "signUp": "Zarejestruj się",
    "preferredVariantHint": "Możesz to zmienić w dowolnym momencie",
    "createAccount": "Utwórz Konto",
    "noAccount": "Nie masz konta?",
    "hasAccount": "Masz już konto?",
    "fields": {
      "username": "Nazwa użytkownika",
      "email": "Email",
      "password": "Hasło",
      "confirmPassword": "Potwierdź Hasło",
      "emailOrUsername": "Email lub Nazwa użytkownika"
    },
    "placeholders": {
      "chooseUsername": "Wybierz nazwę użytkownika",
      "yourEmail": "twoj@email.pl",
      "atLeast8Chars": "Minimum 8 znaków",
      "confirmYourPassword": "Potwierdź swoje hasło",
      "enterEmailOrUsername": "Wprowadź email lub nazwę użytkownika",
      "yourPassword": "Twoje hasło"
    },
    "errors": {
      "passwordsNoMatch": "Hasła nie są zgodne",
      "passwordTooShort": "Hasło musi mieć minimum 8 znaków",
      "usernameTooShort": "Nazwa użytkownika musi mieć minimum 3 znaki",
      "passwordRequirements": "Hasło musi zawierać co najmniej jedną wielką literę, jedną małą literę i jedną cyfrę",
      "network": "Brak połączenia z internetem. Sprawdź połączenie i spróbuj ponownie.",
      "guestLoginFailed": "Nie udało się rozpocząć sesji gościa. Sprawdź połączenie i spróbuj ponownie.",
      "guestLoginRateLimited": "Zbyt wiele logowań gościa z tej sieci. Spróbuj za kilka minut albo zaloguj się na swoje konto."
    },
    "validation": {
      "usernameChars": "Tylko litery, cyfry i podkreślenia",
      "invalidEmail": "Podaj prawidłowy adres e-mail",
      "min8": "8+ znaków",
      "uppercase": "wielka litera",
      "lowercase": "mała litera",
      "number": "cyfra"
    },
    "playAsGuest": "Graj jako gość",
    "guestBanner": "Grasz jako gość.",
    "guestBannerCta": "Zarejestruj się, aby zapisać swoje postępy.",
    "guestUpgrade": "Utwórz konto",
    "guestRestriction": "Ta funkcja wymaga zarejestrowanego konta",
    "guestCannotTournament": "Zarejestruj się, aby dołączyć do turniejów",
    "guestCannotChallenge": "Zarejestruj się, aby wyzwać graczy",
    "forgotPassword": "Nie pamiętasz hasła?",
    "forgotPasswordDesc": "Wpisz swój adres e-mail, a wyślemy Ci link do zresetowania hasła.",
    "sendResetLink": "Wyślij link",
    "resetEmailSent": "Sprawdź swoją pocztę",
    "checkSpam": "Nie widzisz? Sprawdź folder spam.",
    "backToLogin": "Powrót do logowania",
    "resetPassword": "Zresetuj hasło",
    "resetPasswordDesc": "Wpisz poniżej swoje nowe hasło.",
    "newPassword": "Nowe hasło",
    "confirmPassword": "Potwierdź hasło",
    "resetSuccess": "Hasło zostało zaktualizowane. Możesz się teraz zalogować.",
    "resetExpired": "Ten link wygasł. Poproś o nowy.",
    "resetInvalid": "Nieprawidłowy lub wygasły link resetowania.",
    "verifyEmail": {
      "title": "Sprawdź swój e-mail",
      "checkInbox": "Wysłaliśmy link weryfikacyjny na {{email}}. Kliknij link, aby aktywować konto.",
      "spamHint": "Nie widzisz? Sprawdź folder spam.",
      "pageTitle": "Weryfikacja e-maila",
      "verifying": "Weryfikacja e-maila...",
      "success": "Adres e-mail zweryfikowany. Twoje konto jest aktywne.",
      "successAndBack": "Adres e-mail zweryfikowany. Wracamy do turnieju.",
      "verifyButton": "Zweryfikuj mój e-mail",
      "error": "Weryfikacja nie powiodła się. Spróbuj ponownie.",
      "loginBlocked": "Zweryfikuj swój e-mail przed zalogowaniem",
      "resendLink": "Wyślij ponownie e-mail weryfikacyjny",
      "resendSent": "E-mail weryfikacyjny wysłany!",
      "enterEmailToResend": "Zaloguj się adresem e-mail, aby ponownie wysłać weryfikację",
      "wrongAddress": "Zły adres?",
      "changeAddress": "Popraw adres",
      "newAddressLabel": "Nowy adres e-mail",
      "passwordLabel": "Hasło, które przed chwilą wybrałeś",
      "changeSubmit": "Wyślij na nowy adres",
      "changeSent": "Jeśli konto istnieje i czeka na weryfikację, wysłaliśmy link na nowy adres.",
      "changeFailed": "Nie udało się zmienić adresu. Spróbuj za kilka minut."
    }
  },
  "profile": {
    "title": "Profil",
    "notFound": "Profil Nie Znaleziony",
    "userNotFound": "Użytkownik nie znaleziony",
    "memberSince": "Członek od {{date}}",
    "goBack": "Wróć",
    "loadingProfile": "Ładowanie profilu...",
    "tabs": {
      "overview": "Przegląd",
      "games": "Gry",
      "stats": "Statystyki"
    },
    "variants": {
      "all": "Wszystkie"
    },
    "stats": {
      "rating": "Rating",
      "games": "Gry",
      "wins": "Wygrane",
      "losses": "Przegrane",
      "draws": "Remisy",
      "winRate": "Procent Wygranych",
      "winRateShort": "Skutecz.",
      "winLossBreakdown": "Zwycięstwa · Remisy · Porażki",
      "peakRating": "Szczyt",
      "streak": "Seria",
      "bestStreak": "Najlepsza",
      "avgTime": "Śr. Czas",
      "title": "Szczegółowe Statystyki",
      "comingSoon": "Wkrótce...",
      "loading": "Ładowanie statystyk...",
      "noData": "Brak gier. Zagraj kilka partii, aby zobaczyć swoje statystyki!",
      "byTimeControl": "Wydajność wg Kontroli Czasu",
      "byColor": "Wydajność wg Koloru",
      "general": "Ogólne",
      "asWhite": "Jako Białe",
      "asBlack": "Jako Czarne",
      "totalGames": "Łączna Liczba Gier",
      "avgMoves": "Średnia Ruchów",
      "gamesShort": "gier",
      "mostActive": "Najaktywniejsi gracze",
      "mostActiveEmpty": "Brak partii w tym wariancie.",
      "viewFullLeaderboard": "Zobacz pełny ranking",
      "ratingEvolution": "Zmiana rankingu · ostatnie 30 dni",
      "chartComingSoon": "Historia wkrótce",
      "peakShort": "Szczyt",
      "barraEsito": "{{win}}% zwycięstw, {{draw}}% remisów, {{loss}}% porażek",
      "percentualeVittorie": "{{rate}}% zwycięstw",
      "siglaVittorie": "Z",
      "siglaPatte": "R",
      "siglaSconfitte": "P"
    },
    "games": {
      "today": "Dzisiaj",
      "yesterday": "Wczoraj",
      "daysAgo": "{{days}} dni temu",
      "weeksAgo": "{{weeks}} tyg. temu",
      "moves": "ruchy",
      "sourceArena": "Arena",
      "sourceTournament": "Turniej",
      "loading": "Ładowanie gier...",
      "noGames": "Nie znaleziono gier",
      "clearFilters": "Wyczyść filtry",
      "clearFiltersActive": "Wyczyść aktywne filtry",
      "loadMore": "Załaduj Więcej",
      "showing": "{{count}} gier",
      "clickViewAll": "Kliknij \"Zobacz wszystkie\" dla historii gier",
      "filterResult": "Wynik",
      "filterTimeControl": "Tempo",
      "filterVariant": "Wariant",
      "filterOpponent": "Przeciwnik",
      "filters": {
        "all": "Wszystkie",
        "wins": "Wygrane",
        "draws": "Remisy",
        "losses": "Przegrane",
        "allVariants": "Wszystkie Warianty",
        "allTimeControls": "Wszystkie Kontrole Czasu",
        "vsMe": "Ze mną"
      }
    },
    "challenge": "Wyzwij",
    "settings": "Ustawienia",
    "gameSettings": "Ustawienia gry",
    "preferredVariant": "Preferowany wariant",
    "preferredCadence": "Preferowane tempo",
    "accountSettings": "Konto",
    "audioHaptics": "Dźwięk i Wibracje",
    "changePassword": "Zmień hasło",
    "changePasswordSub": "Zaktualizuj swoje hasło",
    "currentPassword": "Aktualne hasło",
    "newPassword": "Nowe hasło",
    "passwordChanged": "Hasło zmienione pomyślnie",
    "analyticsLabel": "Analityczne pliki cookie",
    "language": "Język",
    "country": "Kraj",
    "countryNone": "Nie ustawiono",
    "logout": "Wyloguj",
    "logoutSub": "Wyloguj się z konta",
    "exportData": "Eksportuj moje dane",
    "exportDataSub": "Pobierz JSON swoich danych",
    "deleteAccount": {
      "button": "Usuń konto",
      "sub": "Trwale usuń swoje konto",
      "title": "Usuń Konto",
      "warning": "Ta akcja jest nieodwracalna. Wszystkie twoje dane zostaną usunięte.",
      "confirmPassword": "Wprowadź hasło, aby potwierdzić",
      "confirm": "Usuń na stałe",
      "error": "Nie udało się usunąć konta"
    },
    "graphics": {
      "title": "Grafika",
      "pieceShape": "Kształt pionków",
      "pieceStyle": "Styl pionków",
      "kingIcon": "Ikona damki",
      "pieceColor": "Kolor pionków",
      "pieceColorAutoHint": "Kolory pionków zmieniają się zależnie od wariantu.",
      "pieceMaterial": "Materiał pionków",
      "boardColor": "Kolor planszy",
      "boardColorAutoHint": "Kolory planszy zmieniają się zależnie od wariantu.",
      "boardMaterial": "Materiał planszy",
      "boardNotation": "Notacja planszy",
      "notation": "Notacja",
      "shapes": {
        "round": "Okrągły",
        "donut": "Obwarzanek",
        "square": "Kwadrat",
        "rhombus": "Romb",
        "triangle": "Trójkąt",
        "star": "Gwiazda",
        "heart": "Serce"
      },
      "styles": {
        "3d-stacked-engraved": "3D piętrowy, ryty",
        "3d-stacked-smooth": "3D piętrowy, gładki",
        "3d-crown": "3D z koroną",
        "flat-plain": "Płaski, gładki",
        "flat-engraved": "Płaski, grawerowany"
      },
      "kingIcons": {
        "crown": "Korona",
        "ring": "Pierścień",
        "star": "Gwiazda",
        "diamond": "Diament",
        "none": "Brak"
      },
      "crownType": "Typ korony",
      "crownTypes": {
        "classic": "Klasyczna",
        "plain": "Prosta",
        "diadem": "Diadem",
        "lily": "Lilijkowa",
        "imperial": "Cesarska"
      },
      "pieceColors": {
        "auto": "Auto (wg wariantu)",
        "custom": "Własny…",
        "italian": "Włoskie",
        "international": "Międzynarodowe",
        "english": "Angielskie",
        "brazilian": "Brazylijska",
        "classic": "Klasyczny",
        "white-black": "Biały/Czarny",
        "red-black": "Czerwony/Czarny",
        "blue-red": "Niebieski/Czerwony",
        "orange-blue": "Pomarańczowy/Niebieski (daltonizm)",
        "silver-gold": "Srebrny/Złoty",
        "coral-teal": "Koralowy/Turkusowy",
        "green-purple": "Zielony/Fioletowy",
        "pink-navy": "Różowy/Granatowy"
      },
      "materials": {
        "plastic": "Plastik",
        "marble": "Marmur",
        "glass": "Szkło",
        "wood": "Drewno"
      },
      "boards": {
        "auto": "Auto (wg wariantu)",
        "custom": "Własny…",
        "wood-classic": "Międzynarodowe",
        "italian": "Włoskie",
        "english": "Angielskie",
        "brazilian": "Brazylijska",
        "walnut": "Orzech",
        "green-cream": "Zielony/Krem",
        "blue-grey": "Niebieski/Szary",
        "marble": "Marmur",
        "high-contrast": "Wysoki kontrast",
        "mahogany": "Mahoń",
        "ocean": "Ocean",
        "purple-lavender": "Fiolet/Lawenda",
        "rose": "Róż"
      },
      "notations": {
        "none": "Brak",
        "numeric": "Liczby",
        "algebraic": "Współrzędne"
      },
      "hue": "Barwa",
      "customPieceLight": "Jasne pionki",
      "customPieceDark": "Ciemne pionki",
      "customBoardLight": "Jasne pola",
      "customBoardDark": "Ciemne pola",
      "picker": {
        "edit": "Edytuj kolory",
        "hex": "Szesnastkowy",
        "area": "Nasycenie i jasność",
        "saturation": "Nasycenie",
        "brightness": "Jasność",
        "tooClose": "Te dwa kolory są bardzo podobne — pionki lub pola mogą być trudne do odróżnienia."
      },
      "uiTheme": "Motyw aplikacji",
      "themes": {
        "light": "Jasny",
        "dark": "Ciemny"
      }
    },
    "game": {
      "title": "Gra",
      "moveSound": "Włącz dźwięk ruchów",
      "lowTimeSound": "Włącz dźwięk niskiego czasu",
      "notificationSound": "Włącz dźwięki powiadomień",
      "vibration": "Włącz wibracje przy ruchach"
    },
    "gameplay": {
      "title": "Rozgrywka",
      "showMoveHints": "Pokaż możliwe ruchy",
      "showLastMove": "Podświetl ostatni ruch",
      "showLastMoveCaptures": "Podświetl bicia",
      "premove": "Włącz przedruchy"
    },
    "avatar": {
      "title": "Wybierz awatar",
      "choose": "Dostępne awatary",
      "remove": "Brak awatara",
      "edit": "Zmień awatar",
      "presets": {
        "crown": "Korona",
        "star": "Gwiazda",
        "flame": "Płomień",
        "zap": "Błyskawica",
        "shield": "Tarcza",
        "rocket": "Rakieta",
        "gem": "Klejnot",
        "leaf": "Liść",
        "moon": "Księżyc",
        "sun": "Słońce",
        "heart": "Serce",
        "ghost": "Duch"
      }
    },
    "viewProfileOf": "Zobacz profil gracza {{username}}",
    "report": {
      "trigger": "Zgłoś {{username}}",
      "title": "Zgłoś {{username}}",
      "intro": "Napisz, co jest nie tak z tym profilem. Moderator to sprawdzi.",
      "reasonLabel": "Powód",
      "reasons": {
        "offensive_username": "Obraźliwa nazwa użytkownika",
        "offensive_avatar": "Obraźliwe zdjęcie profilowe",
        "harassment": "Nękanie lub groźby",
        "spam": "Spam lub reklama",
        "other": "Inny"
      },
      "noteLabel": "Szczegóły (opcjonalnie)",
      "notePlaceholder": "Cokolwiek, co pomoże nam zrozumieć",
      "privacyHint": "Zgłoszenie jest przechowywane {{days}} dni do celów moderacji. Profil jest publiczny: nie zapisujemy jego kopii.",
      "submit": "Wyślij zgłoszenie",
      "sending": "Wysyłanie...",
      "done": "Zgłoszenie wysłane. Dziękujemy.",
      "errors": {
        "duplicate": "Już zgłosiłeś tego gracza. Moderator się tym zajmuje.",
        "notFound": "Ten gracz nie jest już dostępny.",
        "self": "Nie możesz zgłosić samego siebie.",
        "registeredOnly": "Aby zgłosić z tego miejsca, potrzebujesz zarejestrowanego konta.",
        "rateLimited": "Zbyt wiele zgłoszeń. Spróbuj później.",
        "generic": "Nie udało się wysłać zgłoszenia. Spróbuj ponownie."
      }
    }
  },
  "gamesHistory": {
    "title": "Historia Gier",
    "gamesPlayed": "{{count}} rozegranych gier",
    "noGames": "Brak gier. Zagraj online, aby je tu zobaczyć!",
    "signInToView": "Zaloguj się, aby zobaczyć historię gier.",
    "loadingGames": "Ładowanie gier...",
    "loadingGame": "Ładowanie gry...",
    "failedToLoad": "Nie udało się załadować gier",
    "moves": "{{count}} ruchów"
  },
  "replay": {
    "backToGames": "Powrót do Gier",
    "loadFailed": "Nie udało się otworzyć tej partii. Spróbuj ponownie.",
    "result": {
      "whiteWins": "Białe wygrywają",
      "blackWins": "Czarne wygrywają",
      "draw": "Remis"
    },
    "controls": {
      "goToStart": "Idź na początek",
      "previousMove": "Poprzedni ruch",
      "nextMove": "Następny ruch",
      "goToEnd": "Idź na koniec",
      "play": "Odtwórz",
      "pause": "Pauza",
      "showMoves": "Pokaż ruchy",
      "hideMoves": "Ukryj ruchy",
      "position": "Pozycja w partii"
    },
    "downloadPdn": "Pobierz PDN",
    "analyzeGame": "Analizuj partię",
    "share": "Udostępnij",
    "shareCopied": "Link skopiowany!",
    "shareTitle": "Partia warcabów",
    "shareText": "Zobacz tę partię warcabów",
    "shareSheet": {
      "pdnTitle": "Pobierz PDN",
      "withNotes": "Z moimi notatkami ({{count}})",
      "withoutNotes": "Bez notatek",
      "pdnIntro": "Notatki stają się komentarzami w pliku PDN."
    }
  },
  "review": {
    "save": {
      "save": "Zapisz partię",
      "saved": "Zapisana",
      "title": "Zapisz partię",
      "intro": "Wybierz folder, aby później odnaleźć tę partię.",
      "confirm": "Zapisz",
      "remove": "Usuń z zapisanych",
      "error": "Nie udało się zapisać partii"
    },
    "folders": {
      "unsorted": "Bez folderu",
      "newLabel": "Nowy folder",
      "newPlaceholder": "Nazwa folderu",
      "create": "Utwórz",
      "duplicate": "Folder o tej nazwie już istnieje",
      "rename": "Zmień nazwę",
      "renameFolder": "Zmień nazwę „{{name}}”",
      "renameLabel": "Nowa nazwa folderu",
      "renameError": "Nie udało się zmienić nazwy folderu",
      "delete": "Usuń",
      "deleteFolder": "Usuń „{{name}}”",
      "deleteConfirm": "Usunąć?",
      "deleteHint": "Partie nie zostaną usunięte: wrócą do „Bez folderu”.",
      "deleteError": "Nie udało się usunąć folderu",
      "filterLabel": "Folder",
      "savedOnly": "Tylko zapisane",
      "gameCount_one": "{{count}} partia",
      "gameCount_few": "{{count}} partie",
      "gameCount_many": "{{count}} partii",
      "gameCount_other": "{{count}} partii"
    },
    "notes": {
      "add": "Dodaj notatkę",
      "atStart": "Notatka do pozycji początkowej",
      "atMove": "Notatka przy ruchu {{ply}}",
      "placeholder": "Zapisz notatkę o tej pozycji…",
      "save": "Zapisz notatkę",
      "delete": "Usuń notatkę",
      "jumpTo": "Przejdź do notatki przy ruchu {{ply}}",
      "error": "Nie udało się zapisać notatki",
      "hasNote": "Ta pozycja ma notatkę"
    }
  },
  "leaderboard": {
    "title": "Ranking",
    "subtitle": "Top 100 Graczy",
    "loading": "Ładowanie rankingu...",
    "empty": "Brak graczy z ukończonymi grami.",
    "allTime": "Rating",
    "mostGames": "Najaktywniejsi",
    "bullet": "Bullet",
    "blitz": "Blitz",
    "rapid": "Rapid",
    "classical": "Klasyczny",
    "columns": {
      "rank": "#",
      "player": "Gracz",
      "rating": "Rating",
      "class": "Klasa",
      "games": "Gry",
      "days": "Dni",
      "record": "Rekord"
    },
    "period": {
      "label": "Dni",
      "days": "{{days}} dni",
      "all": "Zawsze"
    },
    "emptyPeriod": "Brak gier w tym wariancie w ciągu ostatnich {{days}} dni.",
    "emptyStreak": "Nikt nie ma teraz aktywnego streaka.",
    "classes": {
      "novice": "Początkujący",
      "intermediate": "Średniozaawansowany",
      "advanced": "Zaawansowany",
      "expert": "Ekspert",
      "master": "Mistrz",
      "grandmaster": "Arcymistrz",
      "legend": "Legenda"
    }
  },
  "tournament": {
    "title": "Turnieje",
    "subtitle": "Sprawdź swoje umiejętności w turniejach",
    "list": {
      "heroTitle": "Turnieje",
      "arenasLink": "Zobacz wszystkie areny",
      "archive_one": "Ostatni zakończony turniej.",
      "archive_other": "Ostatnich {{count}} zakończonych turniejów."
    },
    "createTournament": "Utwórz turniej",
    "formats": {
      "arena": "Arena",
      "italoSwiss": "Kołowy/Szwajcarski (zależnie od liczby zapisanych)",
      "swiss": "System szwajcarski",
      "roundRobin": "Round Robin (każdy z każdym)",
      "arenaShort": "Arena",
      "italoSwissShort": "Kołowy/Szwajcarski",
      "swissShort": "Szwajcarski",
      "roundRobinShort": "Kołowy"
    },
    "filters": {
      "all": "Wszystkie",
      "live": "Na Żywo",
      "upcoming": "Nadchodzące",
      "variant": "Wariant",
      "status": "Status",
      "international": "Międzynarodowe",
      "italian": "Włoskie",
      "english": "Angielskie",
      "brazilian": "Brazylijska",
      "comingSoon": "Wkrótce",
      "owner": "Turnieje",
      "mine": "Moje"
    },
    "sections": {
      "live": "Trwające",
      "upcoming": "Nadchodzące",
      "finished": "Zakończone"
    },
    "status": {
      "live": "NA ŻYWO",
      "upcoming": "NADCHODZĄCY",
      "finished": "ZAKOŃCZONY",
      "scheduled": "ZAPLANOWANY",
      "cancelled": "ODWOŁANY"
    },
    "card": {
      "rated": "Rankingowy",
      "registered": "Zapisany",
      "gamesPlayed_one": "{{count}} rozegrana gra",
      "gamesPlayed_few": "{{count}} rozegrane gry",
      "gamesPlayed_many": "{{count}} rozegranych gier",
      "gamesPlayed_other": "{{count}} rozegranych gier",
      "players_one": "{{count}} gracz",
      "players_few": "{{count}} gracze",
      "players_many": "{{count}} graczy",
      "players_other": "{{count}} graczy",
      "starts": "Start {{time}}",
      "startsAt": "Rozpoczyna się o {{time}}",
      "startsAtTomorrow": "Rozpoczyna się jutro o {{time}}",
      "startsAtDate": "Rozpoczyna się {{date}} o {{time}}",
      "startsInCountdown": "Rozpoczyna się za {{time}}",
      "startingNow": "Rozpoczyna się teraz!",
      "privateHint": "Turniej prywatny: potrzebujesz zaproszenia lub hasła",
      "publicHint": "Turniej publiczny: otwarty dla wszystkich",
      "private": "Prywatny",
      "seats": "Miejsca",
      "yourPlace": "ty {{rank}}.",
      "gettoneAlle": "Start o",
      "gettoneDomani": "Jutro o",
      "gettoneData": "{{date}} o",
      "gettoneTra": "Start za",
      "gettoneMin": "min"
    },
    "games": {
      "allGames": "Wszystkie partie",
      "myGames": "Moje partie",
      "noGames": "Brak rozegranych partii",
      "moves": "ruchów",
      "analyze": "Analizuj",
      "round": "Runda {{n}}"
    },
    "participants": {
      "sortByScore": "Wg punktów",
      "sortByRating": "Wg ratingu",
      "sortByName": "A-Z",
      "status": {
        "playing": "Gra",
        "online": "Online",
        "offline": "Offline"
      }
    },
    "matchFound": {
      "title": "Znaleziono przeciwnika!",
      "opponent": "Przeciwnik",
      "playAsWhite": "Grasz białymi",
      "playAsBlack": "Grasz czarnymi",
      "startingIn": "Zaczyna się za...",
      "startNow": "Zacznij teraz"
    },
    "postGame": {
      "currentRank": "Aktualna pozycja",
      "continue": "Kontynuuj"
    },
    "empty": {
      "live": "Brak turniejów na żywo w tej chwili.",
      "upcoming": "Brak zaplanowanych turniejów.",
      "all": "Brak dostępnych turniejów.",
      "mine": "Nie masz jeszcze turniejów. Utwórz turniej lub dołącz przez zaproszenie.",
      "finished": "Brak zakończonych turniejów.",
      "goLive": "Zobacz trwające",
      "goUpcoming": "Zobacz nadchodzące",
      "goFinished": "Zobacz archiwum"
    },
    "loading": "Ładowanie turniejów...",
    "notFound": "Turniej nie znaleziony",
    "detail": {
      "timeControl": "Kontrola Czasu",
      "duration": "Czas Trwania",
      "players": "Gracze",
      "games": "Gry",
      "startsIn": "Start {{time}}",
      "joinTournament": "Dołącz do Turnieju",
      "register": "Zapisz się",
      "unregister": "Wypisz się",
      "leaveTournament": "Opuść Turniej",
      "yourStats": "Twoje Statystyki",
      "points": "Punkty",
      "rank": "Pozycja",
      "askPassword": "Hasło turnieju",
      "share": "Udostępnij zaproszenie",
      "shareStandings": "Udostępnij klasyfikację",
      "shareCopied": "Skopiowano link",
      "cancelTournament": "Anuluj turniej",
      "cancelConfirm": "Turniej zniknie, a zapisani gracze zostaną powiadomieni. Tego nie można cofnąć.",
      "cancelYes": "Tak, anuluj",
      "cancelNo": "Nie, zostaw",
      "createdBy": "Utworzony przez {{username}}",
      "regenerate": "Nowe klucze",
      "regenerateHint": "Stary link przestaje działać. Wybierz nowe hasło i wyślij zaproszenie ponownie.",
      "regenerateNewPassword": "Nowe hasło",
      "regenerateConfirm": "Utwórz nowe klucze",
      "regenerateCancel": "Zostaw",
      "regenerateDone": "Nowe klucze gotowe: stary link już nie działa",
      "ratingFloor": "Minimalny ranking",
      "aiutoAssenza": "Co się stanie, jeśli nie zagram?",
      "aiutoApertura": "Dlaczego niektóre partie zaczynają się od już zagranych ruchów?",
      "formatoTitolo": "Jak wybierany jest format",
      "formatoOraGirone": "Przy obecnej liczbie zapisanych ({{n}}) byłby to turniej kołowy.",
      "formatoOraSvizzero": "Przy obecnej liczbie zapisanych ({{n}}) byłby to system szwajcarski.",
      "formatoOraPochi": "Do startu potrzeba co najmniej {{min}} zapisanych: teraz jest {{n}}.",
      "formatoPrevisto": "Przewidywany",
      "seSvizzero": "Jeśli system szwajcarski",
      "seGirone": "Jeśli turniej kołowy",
      "punteggio": "Punktacja"
    },
    "scoring": {
      "title": "Punktacja Arena",
      "win": "Wygrana: +{{points}}",
      "draw": "Remis: +{{points}}"
    },
    "standings": {
      "title": "Klasyfikacja",
      "liveStandings": "Klasyfikacja Na Żywo",
      "empty": "Brak graczy. Bądź pierwszy!",
      "morePlayers_one": "+ {{count}} inny gracz",
      "morePlayers_few": "+ {{count}} inni gracze",
      "morePlayers_many": "+ {{count}} innych graczy",
      "morePlayers_other": "+ {{count}} innych graczy",
      "columns": {
        "rank": "#",
        "player": "Gracz",
        "points": "Punkty",
        "status": "Status",
        "winsDrawsLosses": "Z/R/P",
        "winsDrawsLossesByes": "Z/R/P/W",
        "byes": "Pauza"
      },
      "status": {
        "playing": "Gra",
        "ready": "Gotowy",
        "paused": "Pauza",
        "left": "Opuścił",
        "offline": "Offline",
        "assente": "Nieobecny",
        "haFinito": "Czeka",
        "riposa": "Pauzuje",
        "disconnesso": "Rozłączony"
      },
      "tied": "Ex aequo",
      "tiebreakHelp": "Jak rozstrzyga się równą liczbę punktów?",
      "sdSigla": "BP",
      "sdSpiega": "Wyżej niż {{nomi}} dzięki bezpośrednim pojedynkom graczy z równą liczbą punktów",
      "scoreSheet": {
        "label": "Przebieg: {{esiti}}",
        "outcome": {
          "win": "wygrana",
          "winPlus": "wygrana, warta więcej",
          "draw": "remis",
          "loss": "przegrana",
          "bye": "pauza"
        },
        "clipped": "najstarsze zostają poza kadrem po lewej",
        "hint": "Wszystkie partie, najnowsza po prawej",
        "hintRiposoSvizzero": "kwadrat to pauza i liczy się jak wygrana",
        "hintRiposoGirone": "kwadrat to pauza i nie daje punktów"
      }
    },
    "lobby": {
      "leaveTournament": "Opuść Turniej",
      "waitingForOpponent": "Oczekiwanie na przeciwnika...",
      "pts": "pkt",
      "rank": "poz",
      "yourPosition": "Twoja Pozycja"
    },
    "timer": {
      "remaining": "Pozostało",
      "finished": "Zakończono",
      "started": "Rozpoczęto",
      "daysHours": "{{days}}d {{hours}}h"
    },
    "tabs": {
      "standings": "Klasyfikacja",
      "games": "Gry",
      "details": "Szczegóły",
      "participants": "Uczestnicy",
      "gamesPlaceholder": "Ostatnie gry pojawią się tutaj"
    },
    "rules": {
      "title": "Zasady Punktacji"
    },
    "create": {
      "title": "Utwórz turniej",
      "infoAbout": "Informacje: {{campo}}",
      "nameLabel": "Nazwa Turnieju *",
      "namePlaceholder": "np. Niedzielna Arena Blitz",
      "nameRequired": "Nazwa turnieju jest wymagana",
      "aperturaUnicaHint": "Jedno otwarcie we wszystkich rundach i wszystkich partiach turnieju — przydatne w turnieju tematycznym opartym na jednym otwarciu",
      "aperturaUnicaScelta": "nr {{id}}",
      "aperturaUnicaScegli": "Wybierz otwarcie",
      "aperturaUnicaMancante": "Wybierz otwarcie, aby kontynuować",
      "aperturaUnicaAmichevole": "To otwarcie jest zbyt nierówne, by jedna partia je zrównoważyła: turniej jest towarzyski. Przy dwóch partiach pozostaje rankingowy.",
      "nameLength": "Nazwa musi mieć 3-100 znaków",
      "descriptionLabel": "Opis (opcjonalny)",
      "descriptionPlaceholder": "Opisz swój turniej...",
      "timeControlLabel": "Kontrola Czasu",
      "durationLabel": "Czas Trwania",
      "startsAtLabel": "Godzina rozpoczęcia",
      "startsAtRange": "Od 5 minut do 14 dni od teraz.",
      "startsAtInvalid": "Wybierz godzinę od 5 minut do 14 dni od teraz.",
      "visibilityLabel": "Widoczność",
      "visibilityPublic": "Publiczny",
      "visibilityPrivate": "Prywatny",
      "passwordLabel": "Hasło turnieju",
      "passwordHint": "Będziesz mógł je później odczytać, żeby je udostępnić. Nie używaj hasła do swojego konta.",
      "passwordRequired": "Turniej prywatny wymaga hasła",
      "estimate": "{{players}} graczy, {{rounds}} rund → około {{duration}}, koniec ok. {{end}}",
      "estimateRange": "{{players}} graczy, od {{roundsMin}} do {{roundsMax}} rund → około {{duration}}, koniec najpóźniej ok. {{end}}",
      "durationOptions": {
        "30min": "30 min",
        "1hour": "1 godzina",
        "1.5hours": "1,5 godziny",
        "2hours": "2 godziny",
        "3hours": "3 godziny"
      },
      "minRatingLabel": "Min Rating",
      "maxRatingLabel": "Max Rating",
      "ratedLabel": "Rankingowy",
      "ratingFloorLabel": "Minimalny ranking",
      "ratingFloorHint": "Poniżej tego rankingu nie można wziąć udziału. Liczy się ranking w wariancie i tempie tego turnieju: kto nigdy nie grał tej kombinacji, liczy się jako debiutant. Tylko w turniejach rankingowych.",
      "ratingFloorNone": "Brak",
      "variantLabel": "Wariant",
      "variantInternational": "Międzynarodowe (10×10)",
      "variantItalian": "Włoskie (8×8)",
      "variantEnglish": "Angielskie (8×8)",
      "formatLabel": "Format",
      "maxPlayersLabel": "Maks. graczy",
      "thresholdLabel": "Szwajcarski od",
      "thresholdHint": "Od {{n}} uczestników gra się systemem szwajcarskim; poniżej — kołowym. Liczbę rund ustala start, licząc tych, którzy się zjawili. Przy trzech lub czterech uczestnikach turniej kołowy gra się też rewanżowo: nadal trzy rundy, ale po dwie partie każda, bo jedna partia z każdym to za mało.",
      "extraRoundLabel": "Dodatkowe rundy (system szwajcarski)",
      "extraRoundHint": "Jedna lub dwie rundy więcej, niż daje tabela, na tyle, na ile stawka to zniesie. W turnieju kołowym nic nie zmienia: tam każdy gra z każdym, a jedna runda więcej byłaby rewanżem dla wszystkich.",
      "extraRoundsNone": "Brak",
      "extraRoundsOne": "+1 runda",
      "extraRoundsTwo": "+2 rundy",
      "tooLongWarningSeats": "Ponad dzień gry: usuń kilka miejsc albo skróć tempo.",
      "minPlayersLabel": "Min. graczy",
      "minPlayersHint": "Poniżej tej liczby turniej sam się odwoła o godzinie startu. Im wyżej ją ustawisz, tym bardziej to prawdopodobne.",
      "seatsWarning": "Powyżej tej liczby nikt już nie wejdzie, a później nie zmienisz tej wartości.",
      "submitButton": "Utwórz Turniej",
      "submitting": "Tworzenie...",
      "failedToCreate": "Nie udało się utworzyć turnieju",
      "arenaHint": "Arena nie ma rund: pary dobierane są bez przerwy, aż skończy się czas.",
      "arenaDurationHint": "Jak długo arena pozostaje otwarta. Najwyżej osiem godzin.",
      "arenaSummary": "Arena na {{duration}}, koniec około {{end}}",
      "twoLegLabel": "Mecz i rewanż",
      "twoLegHint": "Każda para gra dwie partie z rzędu, z zamienionymi kolorami.",
      "twoLegItaloHint": "Ci sami dwaj gracze spotykają się dwa razy w tej samej rundzie, zamienionymi kolorami i na tym samym otwarciu: runda trwa dwa razy dłużej, liczba rund się nie podwaja. Przy trzech lub czterech uczestnikach rewanż rozgrywa się zawsze, niezależnie od tego przełącznika.",
      "boostLabel": "Boost",
      "boostHint": "Grający może zaryzykować: oddaje połowę czasu podstawowego i dodatek, a za wygraną dostaje podwójne punkty. Bierze się go przed własnym pierwszym ruchem. Wyłączony — nikt go w tej arenie nie użyje.",
      "roundsHelp": "Ile rund się rozgrywa?"
    },
    "signInToJoin": "Zaloguj się, aby dołączyć do turniejów",
    "roundRobin": {
      "scontroDiretto": "Bezpośredni pojedynek między graczami z tą samą liczbą punktów (w tabeli «BP»)",
      "tiebreakerInfo": "Dogrywka: zwycięstwa, bezpośredni pojedynek, Sonneborn-Berger, zmiana rankingu w turnieju"
    },
    "swiss": {
      "roundOf": "Runda {{current}} z {{total}}",
      "scoringWin": "Wygrana: +{{points}}",
      "scoringDraw": "Remis: +{{points}}",
      "scoringLoss": "Przegrana: {{points}}",
      "buchholz": "BH",
      "sb": "SB",
      "variazione": "Δ",
      "variazioneTitolo": "Zmiana rankingu w turnieju",
      "criterioVittorie": "Liczba zwycięstw",
      "tiebreakersTitle": "Rozstrzyganie remisów",
      "buchholzCut1": "Buchholz (Cut 1)",
      "sonnebornBerger": "Sonneborn-Berger (SB)",
      "cannotJoinInProgress": "Ten turniej Swiss już trwa. Nie możesz dołączyć w trakcie turnieju.",
      "returnLegPending": "Rewanż zaraz się zacznie: ci sami przeciwnicy, zamienione kolory.",
      "waitingBetweenRounds": "Oczekiwanie na następną rundę...",
      "waitingFinalResults": "Oczekiwanie na wyniki końcowe...",
      "waitingForRoundEnd": "Oczekiwanie na koniec rundy...",
      "tiebreakerInfo": "Dogrywka: Buchholz Cut 1, Sonneborn-Berger, zwycięstwa, zmiana rankingu w turnieju",
      "byeRoundPunti": "W tej rundzie pauzujesz: +{{punti}} pkt, już w tabeli.",
      "byeRoundNessunPunto": "W tej rundzie pauzujesz: w systemie kołowym pauza nie daje punktów.",
      "byeProssimoTurno": "Następna runda zacznie się sama, gdy skończą się pozostałe partie.",
      "byeUltimoTurno": "Wyniki końcowe pojawią się, gdy skończą się pozostałe partie.",
      "returnLegTra": "Rewanż zaczyna się za {{secondi}} s: ci sami przeciwnicy, zamienione kolory.",
      "partiteConcluse": "Zakończone partie: {{completate}} z {{totali}}",
      "turnoParteDaSolo": "Następna runda ruszy sama",
      "nonCiSiRitira": "Po rozpoczęciu turnieju nie można się wycofać: jeśli nie grasz, nadal jesteś kojarzony i przegrywasz partie na czas."
    },
    "errors": {
      "authRequired": "Zaloguj się, aby wziąć udział w turnieju.",
      "guestNotAllowed": "Turnieje są dla zarejestrowanych kont.",
      "notAllowed": "Operacja niedozwolona.",
      "notFound": "Ten turniej już nie istnieje.",
      "userNotFound": "Nie znaleziono gracza.",
      "invalidInput": "Nieprawidłowe żądanie.",
      "rateLimited": "Zbyt wiele żądań — poczekaj chwilę.",
      "joinFailed": "Nie udało się dołączyć. Spróbuj ponownie.",
      "arenaPiena": "Ta arena jest pełna: nie ma już wolnych miejsc.",
      "arenaChiusa": "Ta arena nie przyjmuje już zapisów.",
      "giaIscritto": "Jesteś już zapisany do tej areny.",
      "arenaAnnullata": "Ta arena została odwołana: o godzinie startu było za mało zapisanych.",
      "notJoinable": "Zapisy do tego turnieju są zamknięte.",
      "roundsStarted": "Runda już się rozpoczęła.",
      "ratingTooLow": "Twój ranking jest niższy od minimum wymaganego w tym turnieju.",
      "wrongFormat": "Niezgodny format turnieju.",
      "privateTournament": "Ten turniej jest prywatny: potrzebujesz linku lub hasła.",
      "wrongPassword": "Nieprawidłowe hasło.",
      "tooManyAttempts": "Zbyt wiele prób. Spróbuj ponownie za kwadrans.",
      "tournamentFull": "Turniej jest pełny.",
      "alreadyHasLive": "Masz już 3 trwające rozgrywki: kolejną otworzysz, gdy jedna z nich się zakończy.",
      "nameTaken": "O tej porze istnieje już turniej o tej nazwie.",
      "startTooSoon": "Za wcześnie: zostaw przynajmniej pięć minut na zaproszenie kogoś.",
      "startTooFar": "Zbyt odległy termin: najwyżej dwa tygodnie od teraz.",
      "notOrganizer": "Może to zrobić tylko organizator.",
      "alreadyStarted": "Turniej już się rozpoczął.",
      "tooLong": "Turniej trwałby ponad dzień: usuń kilka rund albo skróć tempo.",
      "cancelledByOrganizer": "Organizator anulował ten turniej.",
      "cancelledNoPlayers": "Turniej został anulowany: zapisało się za mało graczy.",
      "serverError": "Błąd serwera. Spróbuj później.",
      "offline": "Wygląda na brak połączenia — sprawdź sieć.",
      "timeout": "Serwer nie odpowiedział. Spróbuj ponownie.",
      "loadFailed": "Nie udało się wczytać turniejów.",
      "notYourTurn": "Nie twoja kolej.",
      "drawOfferFailed": "Nie udało się zaproponować remisu.",
      "unknown": "Coś poszło nie tak. Spróbuj ponownie.",
      "moveRejected": "Serwer odrzucił twój ruch: plansza wróciła do poprzedniego stanu.",
      "partitaSvanita": "Partia nie istnieje już na serwerze: prawdopodobnie został zrestartowany. Wróciłeś do poczekalni turnieju.",
      "notInTournament": "Nie jesteś zapisany do tego turnieju.",
      "tournamentFullWayOut": "Zobacz inne turnieje i areny",
      "notPrivate": "Ten turniej jest publiczny: nie ma kluczy do odnowienia",
      "samePassword": "Nowe hasło jest takie samo jak poprzednie",
      "tournamentCancelled": "Turniej został odwołany.",
      "inviteLinkExpired": "Ten link z zaproszeniem już nie działa: dołącz przy użyciu hasła."
    },
    "ended": {
      "title": "Turniej zakończony",
      "winner": "Zwycięzca",
      "noWinner": "Brak zwycięzcy: nie rozegrano żadnej partii.",
      "tiedWith": "Pierwsze miejsce ex aequo z {{players}}"
    },
    "share": {
      "title": "Turniej warcabowy",
      "text": "Zapraszamy na turniej {{nome}} na draughtsgame.com",
      "standingsTitle": "Klasyfikacja końcowa — {{nome}}"
    }
  },
  "chat": {
    "title": "Czat",
    "openChat": "Otwórz czat",
    "closeChat": "Zamknij czat",
    "empty": "Brak wiadomości. Przywitaj się!",
    "placeholder": "Napisz wiadomość...",
    "unavailable": "Czat niedostępny",
    "opponentLeft": "Przeciwnik opuścił partię.",
    "rateLimited": "Piszesz za szybko: odczekaj kilka sekund.",
    "closingIn": "Czat zamknie się za {{seconds}}s",
    "closed": "Czat tej partii jest zamknięty.",
    "guestHint": "Goście mogą wysyłać szybkie reakcje. Zarejestruj się, aby korzystać z pełnego czatu.",
    "report": {
      "trigger": "Zgłoś",
      "title": "Zgłoś gracza {{username}}",
      "intro": "Powiedz nam, co się stało. Moderator sprawdzi czat tej partii.",
      "quoteLabel": "Ostatnia wiadomość od {{username}}",
      "reasonLabel": "Powód",
      "reasons": {
        "insult": "Obelgi lub obraźliwy język",
        "harassment": "Nękanie lub groźby",
        "hate_speech": "Mowa nienawiści lub dyskryminacja",
        "spam": "Spam lub reklama",
        "other": "Coś innego"
      },
      "noteLabel": "Szczegóły (opcjonalnie)",
      "notePlaceholder": "Cokolwiek, co pomoże nam zrozumieć",
      "privacyHint": "Czat tej partii (do 100 wiadomości, od obu graczy) jest zapisywany na potrzeby moderacji i przechowywany przez {{days}} dni.",
      "submit": "Wyślij zgłoszenie",
      "sending": "Wysyłanie...",
      "done": "Zgłoszenie wysłane. Dziękujemy.",
      "muted": "Zgłosiłeś tego gracza. Jego wiadomości są ukryte.",
      "errors": {
        "gone": "Ta partia się zakończyła i jej czatu nie da się już zweryfikować. Napisz do nas ze strony Pomoc.",
        "duplicate": "Już zgłosiłeś tego gracza za tę partię.",
        "notReportable": "Tego przeciwnika nie można zgłosić.",
        "notInGame": "Nie grasz w tej partii.",
        "rateLimited": "Zbyt wiele zgłoszeń. Spróbuj ponownie później.",
        "generic": "Nie udało się wysłać zgłoszenia. Spróbuj ponownie."
      }
    },
    "quickPhrases": "Szybkie zwroty",
    "presets": {
      "hello": "Cześć!",
      "goodLuck": "Dobrej gry!",
      "haveFun": "Dobrej zabawy!",
      "goodGame": "Dobra partia!",
      "untilNext": "Do następnego razu!",
      "thanks": "Dzięki!"
    }
  },
  "landing": {
    "nav": {
      "title": "Dama Online",
      "play": "Graj",
      "tournaments": "Turnieje",
      "learn": "Nauka",
      "community": "Społeczność",
      "login": "Zaloguj się"
    },
    "hero": {
      "badge": "Najlepsze Doświadczenie Warcabów",
      "title": "Zostań Mistrzem Warcabów",
      "subtitle": "Graj z graczami z całego świata, bierz udział w turniejach i rozwijaj swoje umiejętności dzięki zaawansowanym narzędziom treningowym.",
      "playFree": "Graj Teraz",
      "watchDemo": "Zobacz Demo"
    },
    "stats": {
      "players": "Aktywnych Graczy",
      "games": "Rozegranych Partii",
      "variants": "Warianty Gry",
      "tournaments": "Codzienne Turnieje"
    },
    "features": {
      "title": "Dlaczego Dama Online?",
      "subtitle": "Wszystko czego potrzebujesz, aby zostać mistrzem warcabów",
      "variants": {
        "title": "Wiele Wariantów",
        "description": "Graj w warcaby Włoskie, Międzynarodowe, Angielskie i Brazylijskie - wszystko na jednej platformie."
      },
      "matchmaking": {
        "title": "Inteligentne Matchmaking",
        "description": "Nasz system rankingowy Glicko-2 zapewnia uczciwe i konkurencyjne mecze."
      },
      "tournaments": {
        "title": "Turnieje Arena",
        "description": "Rywalizuj w codziennych turniejach z graczami z całego świata."
      },
      "ai": {
        "title": "Trening z AI",
        "description": "Ćwicz z naszą zaawansowaną sztuczną inteligencją na wielu poziomach trudności."
      },
      "analysis": {
        "title": "Analiza Partii",
        "description": "Przeglądaj swoje partie i ucz się na błędach dzięki szczegółowej analizie."
      },
      "community": {
        "title": "Aktywna Społeczność",
        "description": "Dołącz do klubów, rozmawiaj z graczami i poznawaj przyjaciół dzielących twoją pasję."
      }
    },
    "variants": {
      "title": "Graj w Ulubiony Wariant",
      "subtitle": "Wspieramy najpopularniejsze warianty warcabów z całego świata",
      "pieces": "pionków",
      "italian": "Warcaby Włoskie",
      "international": "Warcaby Międzynarodowe",
      "english": "Warcaby Angielskie",
      "brazilian": "Warcaby Brazylijskie"
    },
    "testimonials": {
      "1": {
        "name": "Marco B.",
        "role": "Gracz Turniejowy",
        "text": "Najlepsza platforma warcabów jakiej używałem. Matchmaking jest uczciwy a turnieje ekscytujące!"
      },
      "2": {
        "name": "Elena V.",
        "role": "Gracz Okazjonalny",
        "text": "Uwielbiam jak łatwo można znaleźć grę. Interfejs jest piękny i intuicyjny."
      },
      "3": {
        "name": "Hans K.",
        "role": "Mistrz Klubu",
        "text": "Wreszcie platforma, która traktuje warcaby międzynarodowe poważnie. Gorąco polecam!"
      },
      "title": "Co Mówią Gracze"
    },
    "cta": {
      "title": "Gotowy do Gry?",
      "subtitle": "Dołącz do tysięcy graczy i rozpocznij swoją przygodę z warcabami już dziś.",
      "button": "Zacznij Grać Teraz"
    },
    "footer": {
      "tagline": "Wiodąca platforma warcabów online",
      "game": "Gra",
      "playNow": "Graj Teraz",
      "tournaments": "Turnieje",
      "leaderboard": "Ranking",
      "puzzles": "Łamigłówki",
      "learn": "Nauka",
      "tutorial": "Poradnik",
      "strategies": "Strategie",
      "rules": "Zasady",
      "videos": "Filmy",
      "community": "Społeczność",
      "forum": "Forum",
      "clubs": "Kluby",
      "blog": "Blog",
      "discord": "Discord",
      "rights": "Wszelkie prawa zastrzeżone."
    }
  },
  "arena": {
    "title": "Arena",
    "subtitle": "Szybka ciągła gra",
    "ending": "Kończy się...",
    "status": {
      "live": "NA ŻYWO",
      "upcoming": "NADCHODZĄCA",
      "finished": "ZAKOŃCZONA"
    },
    "card": {
      "yourPlace": "ty {{rank}}."
    },
    "actions": {
      "join": "Dołącz do Areny",
      "leave": "Opuść Arenę",
      "play": "Graj",
      "pause": "Pauza",
      "resume": "Wznów Grę",
      "boost": "Boost",
      "backToGame": "Wróć do partii",
      "retry": "Ponów"
    },
    "errors": {
      "authRequired": "Musisz się zalogować, aby wziąć udział w arenie.",
      "guestNotAllowed": "Goście nie mogą dołączyć do areny. Załóż konto, aby zachować swoje partie.",
      "notAllowed": "To konto nie może dołączyć do areny.",
      "arenaNotFound": "Ta arena już nie istnieje.",
      "userNotFound": "Nie możemy znaleźć twojego konta. Zaloguj się ponownie.",
      "invalidInput": "Żądanie było nieprawidłowe. Odśwież stronę i spróbuj ponownie.",
      "rateLimited": "Zbyt wiele prób. Odczekaj kilka sekund i spróbuj ponownie.",
      "ratingTooLow": "Twój ranking jest niższy od minimum wymaganego na tej arenie.",
      "joinFailed": "Nie udało się zapisać cię do areny. Spróbuj ponownie.",
      "arenaPiena": "Ta arena jest pełna: nie ma już wolnych miejsc.",
      "arenaChiusa": "Ta arena nie przyjmuje już zapisów.",
      "giaIscritto": "Jesteś już zapisany do tej areny.",
      "arenaScaduta": "Czas tej areny się skończył: czekamy tylko na koniec ostatnich partii.",
      "arenaAnnullata": "Ta arena została odwołana.",
      "arenaAnnullataPochiIscritti": "Ta arena została odwołana: o godzinie startu było za mało zapisanych.",
      "arenaAnnullataDaOrganizzatore": "Osoba, która otworzyła tę arenę, ją odwołała.",
      "notOrganizer": "Może to zrobić tylko osoba, która otworzyła arenę.",
      "alreadyStarted": "Arena już się rozpoczęła.",
      "giaInUnArena": "Jesteś już w trwającej arenie: opuść ją, aby zagrać w tej",
      "leaveFailed": "Nie udało się opuścić areny. Spróbuj ponownie.",
      "notInArena": "Nie jesteś zapisany do tej areny.",
      "notInGame": "Nie grasz w tej partii.",
      "gameNotFound": "Ta partia już nie istnieje.",
      "tooLate": "Za późno: boost można zmienić tylko przed pierwszym ruchem.",
      "boostDisabled": "W tej arenie boost jest wyłączony.",
      "alreadyBoosted": "Boost jest już włączony w tej partii.",
      "notBoosted": "Boost nie jest włączony w tej partii.",
      "boostFailed": "Nie udało się włączyć boosta. Spróbuj ponownie.",
      "unboostFailed": "Nie udało się wyłączyć boosta. Spróbuj ponownie.",
      "serverError": "Coś poszło nie tak po naszej stronie. Spróbuj ponownie.",
      "offline": "Brak połączenia z serwerem.",
      "timeout": "Serwer nie odpowiedział. Spróbuj ponownie.",
      "unknown": "Coś poszło nie tak. Spróbuj ponownie.",
      "notYourTurn": "To nie twoja tura.",
      "drawOfferFailed": "Nie udało się wysłać propozycji remisu. Spróbuj ponownie.",
      "moveRejected": "Serwer odrzucił twój ruch: plansza wróciła do poprzedniego stanu."
    },
    "standings": {
      "search": "Szukaj gracza",
      "searchEmpty": "Nie ma gracza o tej nazwie.",
      "sheetHint": "Wszystkie partie, najnowsza po prawej · złoto = bonus",
      "loadMore": "Pokaż więcej",
      "sheet": "Partie",
      "toClimb_one": "{{count}} punkt do awansu",
      "toClimb_few": "{{count}} punkty do awansu",
      "toClimb_many": "{{count}} punktów do awansu",
      "toClimb_other": "{{count}} punktów do awansu",
      "lead_one": "{{count}} punkt przewagi",
      "lead_few": "{{count}} punkty przewagi",
      "lead_many": "{{count}} punktów przewagi",
      "lead_other": "{{count}} punktów przewagi",
      "boostOn": "boost aktywny",
      "searchScope": "Wyszukiwanie obejmuje tylko już wczytane wiersze: wczytaj resztę, aby przeszukać wszystkich.",
      "justPlayedHint": "Znak ↺: właśnie z nim grałeś — obok widać, ile jeszcze zostało, zanim znów będzie mógł ci się trafić.",
      "justPlayedIn": "Już rozegrane: znów dostępny za {{time}}",
      "tiebreakOpp": "Przeciwnicy",
      "tiebreakOppTitle": "Średnia punktów napotkanych przeciwników",
      "tiebreakH2hTitle": "Bezpośredni pojedynek między zawodnikami z równą liczbą punktów: wygrane minus przegrane",
      "tiebreakHint": "Przy równej liczbie punktów: więcej zwycięstw, potem bezpośredni pojedynek, potem silniejsi przeciwnicy, potem mniej rozegranych partii."
    },
    "info": {
      "details": "Szczegóły",
      "scoring": "System Punktacji",
      "loss": "Przegrana: {{points}}",
      "boostTitle": "Boost ⚡",
      "boostTimeCost": "Zabiera ci inkrement i skraca czas podstawowy o połowę",
      "boostExtraPoint": "Podwaja punkty za zwycięstwo",
      "boostBeforeFirst": "Można włączać i wyłączać do pierwszego ruchu"
    },
    "matchFound": {
      "title": "Znaleziono Przeciwnika",
      "opponent": "Przeciwnik",
      "playAsWhite": "Grasz białymi",
      "playAsBlack": "Grasz czarnymi",
      "startingIn": "Start za",
      "startNow": "Rozpocznij Teraz"
    },
    "gameEnd": {
      "win": "Zwycięstwo",
      "loss": "Porażka",
      "draw": "Remis",
      "pointsEarned": "Zdobyte punkty",
      "basePoints": "Punkty bazowe",
      "boostBonus": "Bonus za boost",
      "total": "Razem",
      "pointsVoided": "Partia niezaliczona: żaden z graczy nie otrzymuje punktów",
      "rank": "Pozycja",
      "totalPoints": "Punkty",
      "paused": "Masz pauzę: wznów, kiedy chcesz.",
      "arenaFinished": "Arena zakończona",
      "arenaDraining": "Czas minął: arena zamknie się, gdy skończą się ostatnie partie.",
      "analyze": "Analizuj",
      "pause": "Pauza",
      "playNext": "Kontynuuj",
      "backToArena": "Wróć do areny",
      "resumeFailed": "Nie udało się z powrotem dodać cię do kolejki: sprawdź połączenie i spróbuj ponownie.",
      "returnLegIn_one": "Rewanż za {{count}} sekundę…",
      "returnLegIn_few": "Rewanż za {{count}} sekundy…",
      "returnLegIn_many": "Rewanż za {{count}} sekund…",
      "returnLegIn_other": "Rewanż za {{count}} sekundy…"
    },
    "game": {
      "boost": "Boost",
      "boostRemove": "Usuń",
      "boostRetry": "Ponów"
    },
    "confirmBoost": {
      "title": "Włączyć boost?",
      "halve": "Czas podstawowy zmienia się z {{prima}} na {{dopo}} i tracisz {{incremento}}s dodatku.",
      "halveOnly": "Czas podstawowy zmienia się z {{prima}} na {{dopo}}.",
      "reward": "Jeśli wygrasz, punkty liczą się podwójnie. Możesz go usunąć do swojego pierwszego ruchu.",
      "confirm": "Włącz"
    },
    "results": {
      "arenaFinished": "Arena Zakończona",
      "yourPosition": "Twoja pozycja",
      "outOf_one": "z {{count}} gracza",
      "outOf_few": "z {{count}} graczy",
      "outOf_many": "z {{count}} graczy",
      "outOf_other": "z {{count}} graczy",
      "totalPoints": "Łączne punkty",
      "games": "partie",
      "winRate": "Procent wygranych",
      "share": "Udostępnij",
      "nextArena": "Następna Arena",
      "unavailable": "Nie mamy wyników tej areny.",
      "unavailableSub": "Wróć do listy i otwórz ją ponownie w zakładce „Zakończone”."
    },
    "tabs": {
      "rules": "Zasady"
    },
    "signInToJoin": "Zaloguj się, aby dołączyć do aren",
    "positionCta": "Dołącz i rywalizuj o szczyt rankingu!",
    "band": {
      "searchingTitle": "Szukam przeciwnika",
      "searchingSub": "Gdy tylko znajdę parę, zabiorę cię do partii.",
      "drainingTitle": "Czas się skończył",
      "drainingSub": "Nie paruję już nikogo: gdy skończą się ostatnie partie, pojawi się klasyfikacja końcowa.",
      "pausedTitle": "Masz pauzę",
      "pausedSub": "Nikt nie zostanie z tobą sparowany, dopóki nie wznowisz.",
      "pausedAwaySub": "Wstrzymałem cię, bo aplikacja była w tle. Wznów, kiedy chcesz.",
      "pausedOfflineSub": "Wstrzymałem cię, bo byłeś offline, gdy arena się zaczęła.",
      "pausedOtherArenaSub": "Grasz w drugiej arenie. Gdy tam skończysz, naciśnij Wznów, aby wrócić tu do kolejki.",
      "playingTitle": "Jesteś w partii",
      "playingSub": "Partia wciąż trwa: wróć do niej.",
      "playingSubVs": "Przeciwko {{opponent}} · {{color}}.",
      "waitingTitle": "Jesteś zapisany",
      "waitingSub": "Arena jeszcze się nie zaczęła.",
      "joinTitle": "Nie jesteś zapisany",
      "joinSub": "Dołącz, a sparuję cię z tymi w kolejce."
    },
    "timebar": {
      "endsIn": "Koniec za"
    },
    "games": {
      "deletedPlayer": "Usunięty gracz",
      "loadFailed": "Nie udało się wczytać partii."
    },
    "a11y": {
      "scoreUpdate": "Teraz {{points}} punktów, miejsce {{rank}}"
    },
    "spotlight": {
      "eyebrow": "Arena",
      "daysHours": "{{days}}d {{hours}}h",
      "startsIn": "Zaczyna się za",
      "yourResult": "Zająłeś {{rank}}. miejsce",
      "review": "Zobacz, jak poszło"
    },
    "twoLeg": "Mecz i rewanż",
    "noBoost": "Bez boosta",
    "share": {
      "title": "Arena warcabowa",
      "text": "Masz zaproszenie na arenę {{nome}} na draughtsgame.com"
    },
    "detail": {
      "askPassword": "Hasło areny",
      "share": "Udostępnij zaproszenie",
      "shareCopied": "Link skopiowany",
      "cancelArena": "Odwołaj arenę",
      "cancelConfirm": "Arena zniknie, a wszyscy zapisani dostaną powiadomienie. Tego nie da się cofnąć."
    }
  },
  "specialEvent": {
    "eyebrow": "Wydarzenie specjalne",
    "badge": "Specjalne",
    "organizedBy": "Organizowane przez Draughts Game"
  },
  "legal": {
    "termsTitle": "Regulamin",
    "privacyTitle": "Prywatność",
    "acceptTerms": "Akceptuję <terms>Regulamin</terms> i <privacy>Politykę Prywatności</privacy>",
    "acceptTermsOnly": "Akceptuję <terms>Regulamin</terms>",
    "acceptPrivacyOnly": "Akceptuję <privacy>Politykę Prywatności</privacy>",
    "ageConfirm": "Potwierdzam, że mam co najmniej 16 lat",
    "acceptRequired": "Musisz zaakceptować Regulamin",
    "acceptTermsRequired": "Zaznacz pole, aby zaakceptować Regulamin",
    "acceptPrivacyRequired": "Zaznacz pole, aby zaakceptować Politykę Prywatności",
    "ageRequired": "Zaznacz pole, aby potwierdzić wiek",
    "lastUpdated": "Ostatnia aktualizacja",
    "subtitle": "Twoje prawa i nasze zobowiązania",
    "missingConsents_one": "Zostało {{count}} pole do zaznaczenia",
    "missingConsents_few": "Zostały {{count}} pola do zaznaczenia",
    "missingConsents_many": "Zostało {{count}} pól do zaznaczenia",
    "missingConsents_other": "Zostało {{count}} pól do zaznaczenia"
  },
  "cookies": {
    "message": "Używamy niezbędnych plików cookie, żeby strona działała. Jeśli się zgodzisz, korzystamy też z narzędzi pomiarowych — Umami, żeby wiedzieć, jak strona jest używana, i Sentry, żeby wychwytywać błędy. Możesz odmówić: strona działa tak samo.",
    "acceptAll": "Zaakceptuj wszystkie",
    "rejectAnalytics": "Tylko niezbędne"
  },
  "puzzle": {
    "toPlayAndWin": "zaczynają i wygrywają",
    "black": "Czarne",
    "white": "Białe",
    "dashboard": "Panel",
    "hint": "Podpowiedź",
    "hintTip": "Podpowiedź kosztuje tylko ranking: zadanie przestaje być oceniane, więc nie zyskujesz ani nie tracisz punktów. Nadal liczy się jako rozwiązane i utrzymuje Twój Streak.",
    "solution": "Rozwiązanie",
    "solutionTip": "Pokazanie rozwiązania liczy się jako nieudana próba: tracisz punkty rankingowe, ale dzień nadal liczy się do Twojego Streaka.",
    "continueVsAI": "Graj dalej z AI",
    "playAgain": "Zagraj ponownie",
    "back": "Wstecz",
    "forward": "Dalej",
    "puzzleRating": "Ranking zadania",
    "ratingChange": "Ranking",
    "newRating": "teraz",
    "yourRating": "Twój ranking",
    "solutionMoves": "Rozwiązanie",
    "moves": "ruchy",
    "motifs": "Motywy",
    "motifsRevealed": "odsłonięte",
    "motifsHidden": "odsłonięte po rozwiązaniu",
    "result": {
      "solvedEyebrow": "Rozwiązane",
      "failedEyebrow": "Rozwiązanie",
      "nice": "Dobrze",
      "solving": "rozwiązane.",
      "theLine": "Oto",
      "line": "rozwiązanie."
    },
    "title": "Zagadki",
    "loading": "Wczytywanie zadania…",
    "yourTurn": "Znajdź najlepszy ruch!",
    "correct": "Dobrze!",
    "incorrect": "Niezupełnie",
    "solved": "Zagadka rozwiązana!",
    "failed": "Zagadka nierozwiązana",
    "giveUp": "Poddaj się",
    "nextPuzzle": "Następna zagadka",
    "backToHome": "Powrót do strony głównej",
    "rating": "Rating",
    "daily": "Zagadka dnia",
    "practice": "Trening",
    "share": "Udostępnij",
    "solve": "Rozwiąż",
    "demo": {
      "badge": "Zagadka demonstracyjna",
      "solvedTitle": "Brawo — rozwiązane!",
      "trainTitle": "Chcesz trenować codziennie?",
      "registerPitch": "Załóż darmowe konto: każdego dnia nowa zagadka, inna dla każdego wariantu.",
      "registerCta": "Załóż darmowe konto"
    },
    "retry": "Spróbuj ponownie",
    "shareTitle": "Zagadka dnia",
    "shareText": "Rozwiązałem dzisiejszą zagadkę dnia — a ty dasz radę?",
    "shareCopied": "Link skopiowany!",
    "unavailable": {
      "title": "To zadanie jest niedostępne",
      "link": "Nie udało się otworzyć dzisiejszego zadania. Możliwe, że dla tego wariantu go nie ma albo zerwało połączenie.",
      "session": "Nie udało się rozpocząć tego zadania. Sprawdź połączenie i spróbuj ponownie.",
      "home": "Przejdź na stronę główną"
    },
    "invite": {
      "title": "Dzisiejsza zagadka czeka na Ciebie",
      "body": "Znajomy udostępnił Ci dzisiejszą zagadkę. Codzienne zagadki są zarezerwowane dla zarejestrowanych graczy — załóż darmowe konto lub zaloguj się, aby odblokować planszę.",
      "locked": "Podgląd zablokowany",
      "tryDemo": "W międzyczasie spróbuj zagadki demo",
      "moves_one": "{{count}} ruch",
      "moves_few": "{{count}} ruchy",
      "moves_many": "{{count}} ruchów",
      "moves_other": "{{count}} ruchów"
    },
    "guest": {
      "locked": "Daily puzzles są zarezerwowane dla zarejestrowanych graczy. Zaloguj się lub załóż darmowe konto, aby je rozwiązywać."
    },
    "networkError": "Problem z siecią: ruch nie został zapisany. Spróbuj ponownie."
  },
  "dashboard": {
    "hero": {
      "welcome": "Witaj ponownie",
      "settings": "Ustawienia",
      "ctaPlayNow": "Zagraj teraz",
      "ctaVsComputer": "Zagraj z AI",
      "moreVariants": "Więcej wariantów ({{count}})",
      "logoutConfirmTitle": "Wylogować się?",
      "logoutConfirmBody": "Zostaniesz wylogowany z konta na tym urządzeniu.",
      "ctaDailyPuzzle": "Zadania dnia",
      "themeDark": "Przełącz na motyw ciemny",
      "themeLight": "Przełącz na motyw jasny",
      "doNotDisturbOn": "Nie przeszkadzać",
      "doNotDisturbOff": "Znów dostępny",
      "doNotDisturbBadge": "Zajęty",
      "doNotDisturbTurnOff": "Wyłącz",
      "ratingDeltaUp": "{{points}} punktów więcej w ciągu ostatnich 7 dni",
      "ratingDeltaDown": "{{points}} punktów mniej w ciągu ostatnich 7 dni"
    },
    "notif": {
      "challengedYou": "<b>{{name}}</b> ({{rating}}) wyzwał Cię do <b>{{timeControl}}</b> · {{variant}}",
      "challengedYouNoRating": "<b>{{name}}</b> wyzwał Cię do <b>{{timeControl}}</b> · {{variant}}",
      "accept": "Akceptuj",
      "decline": "Odrzuć"
    },
    "streak": {
      "daysInRow_one": "{{count}} dzień z rzędu",
      "daysInRow_few": "{{count}} dni z rzędu",
      "daysInRow_many": "{{count}} dni z rzędu",
      "daysInRow_other": "{{count}} dni z rzędu",
      "unitLabel_one": "dzień z rzędu",
      "unitLabel_few": "dni z rzędu",
      "unitLabel_many": "dni z rzędu",
      "unitLabel_other": "dni z rzędu",
      "record": "Rekord do pobicia: <b>{{count}} dni</b>",
      "recordTying": "Rekord wyrównany: <b>{{count}} dni</b>",
      "empty": "Zacznij dzisiaj",
      "solvePuzzle": "Rozwiąż zadanie",
      "doneToday": "Zrobione na dziś 🔥",
      "keepHint": "Zagraj lub rozwiąż zadanie, aby utrzymać streak.",
      "last7DaysLabel": "Aktywność z ostatnich 7 dni",
      "festa": {
        "subtitle": "Wróć jutro, aby ją wydłużyć"
      }
    },
    "dailyGoal": {
      "title": "Cel dzienny",
      "label": "Partie",
      "remaining_one": "<b>Jeszcze jedna</b> do ukończenia celu",
      "remaining_few": "<b>Jeszcze {{count}}</b> do ukończenia celu",
      "remaining_many": "<b>Jeszcze {{count}}</b> do ukończenia celu",
      "remaining_other": "<b>Jeszcze {{count}}</b> do ukończenia celu",
      "done": "Cel osiągnięty",
      "targetLabel": "Partie dziennie",
      "editGoal": "Zmień cel",
      "festa": {
        "subtitle": "Dzisiejszy cel osiągnięty"
      }
    },
    "festa": {
      "dismiss": "Dotknij, aby zamknąć"
    },
    "activity": {
      "title": "Aktywność",
      "last3Months": "Ostatnie 3 miesiące",
      "centerGames": "partie",
      "statsGames_one": "{{count}} partia",
      "statsGames_few": "{{count}} partie",
      "statsGames_many": "{{count}} partii",
      "statsGames_other": "{{count}} partii",
      "statsActiveDays_one": "{{count}} aktywny dzień",
      "statsActiveDays_few": "{{count}} aktywne dni",
      "statsActiveDays_many": "{{count}} aktywnych dni",
      "statsActiveDays_other": "{{count}} aktywnych dni",
      "statsPerDay": "{{value}} partii/dzień",
      "empty": "Twoje partie pojawią się tutaj",
      "statsTotalTime": "{{value}} łącznie",
      "tooltipToday": "Dziś",
      "tooltipYesterday": "Wczoraj",
      "legendBucket0": "0",
      "legendBucket1": "1-2",
      "legendBucket2": "3-5",
      "legendBucket3": "6-9",
      "legendBucket4": "10+",
      "duration": {
        "zero": "0 min",
        "minutes_one": "{{count}} min",
        "minutes_few": "{{count}} min",
        "minutes_many": "{{count}} min",
        "minutes_other": "{{count}} min",
        "hours_one": "{{count}}h",
        "hours_few": "{{count}}h",
        "hours_many": "{{count}}h",
        "hours_other": "{{count}}h",
        "hoursMinutes": "{{hours}}h {{minutes}}m"
      },
      "dayMon": "Pn",
      "dayThu": "Cz",
      "daySat": "So",
      "dayTue": "Wt",
      "dayWed": "Śr",
      "dayFri": "Pt",
      "daySun": "Nd"
    },
    "recentGames": {
      "title": "Ostatnie partie",
      "viewAll": "Zobacz wszystkie w profilu →",
      "replay": "Odtwórz",
      "empty": "Brak partii"
    },
    "upcomingTournaments": {
      "title": "Aktywne turnieje",
      "viewAll": "Zobacz →",
      "viewAllAria": "Zobacz wszystkie turnieje",
      "empty": "Brak zaplanowanych turniejów"
    },
    "liveEvent": {
      "emptyTitle": "Turnieje i areny",
      "empty": "Brak wydarzeń na żywo",
      "nextAt": "Następne Daily startuje o {{time}}",
      "minutesLeft_one": "Kończy się za {{count}} minutę",
      "minutesLeft_few": "Kończy się za {{count}} minuty",
      "minutesLeft_many": "Kończy się za {{count}} minut",
      "minutesLeft_other": "Kończy się za {{count}} minut",
      "participants_one": "{{count}} gracz",
      "participants_few": "{{count}} graczy",
      "participants_many": "{{count}} graczy",
      "participants_other": "{{count}} graczy"
    },
    "puzzle": {
      "titleWhiteToMove": "Białe na ruchu\ni wygrywają",
      "titleBlackToMove": "Czarne na ruchu\ni wygrywają",
      "meta": "Znajdź najlepszą sekwencję",
      "cta": "Rozwiąż →",
      "viewAll": "Wszystkie →",
      "tag": {
        "tactic": "Taktyka"
      },
      "solvedNext": "Rozwiązane ✓ · Wróć jutro po następną",
      "tryInternational": "Spróbuj zagadki International →",
      "overlayTitle": "Zadania dnia"
    },
    "avvisoDati": {
      "offline": "Wygląda na brak połączenia — twoje dane się nie wczytały.",
      "server": "Nie udało się wczytać twoich danych.",
      "inCorso": "Ponawiam…",
      "ricarica": "Odśwież"
    },
    "installCard": {
      "eyebrow": "App",
      "title": "Zainstaluj Draughts Game",
      "benefit": "Dodaj ją do ekranu głównego: otwiera się na pełnym ekranie, uruchamia szybciej i stoi obok innych aplikacji.",
      "howTo": "Jak to zrobić?",
      "choose": "Wybierz swoje urządzenie:",
      "os": {
        "android": "Android",
        "ios": "iPhone lub iPad",
        "desktop": "Komputer"
      }
    }
  },
  "pwa": {
    "openInAppText": "Jesteś w przeglądarce WhatsAppa. Otwórz ten link poza nią, aby korzystać z pełnej aplikacji.",
    "openInAppCta": "Otwórz w aplikacji",
    "openInBrowserText": "Jesteś w przeglądarce WhatsAppa. Otwórz ten link w Safari, aby korzystać z pełnej aplikacji.",
    "iosHint": "Dotknij ••• w prawym dolnym rogu, a potem „Otwórz w Safari”.",
    "installText": "Zainstaluj Draughts Game i graj z ekranu głównego.",
    "installCta": "Zainstaluj aplikację",
    "copyLink": "Kopiuj link",
    "linkCopied": "Link skopiowany!",
    "dismiss": "Zamknij"
  },
  "seo": {
    "breadcrumbHome": "Strona główna",
    "landing": {
      "title": "Draughts Game — graj w warcaby online za darmo",
      "description": "Graj w warcaby online za darmo: międzynarodowe, włoskie, tureckie, fryzyjskie i 20 innych odmian. Rozgrywka w czasie rzeczywistym, partie rankingowe, turnieje, przeciwnicy AI i codzienne zadanie."
    },
    "faq": {
      "title": "Często zadawane pytania — warcaby online",
      "description": "Odpowiedzi o kontach, rankingu, turniejach, instalacji aplikacji i grze w warcaby online, a także bezpośredni kanał zgłoszeń i sugestii."
    },
    "terms": {
      "title": "Regulamin — Draughts Game",
      "description": "Warunki korzystania z Draughts Game: konta, uczciwa gra, ranking, treści i zasady akceptowane przez obie strony."
    },
    "privacy": {
      "title": "Polityka prywatności — Draughts Game",
      "description": "Jakie dane zbiera Draughts Game, po co, jak długo je przechowuje i jakie masz do nich prawa zgodnie z RODO."
    }
  }
}
